import html2canvas from "html2canvas";

import ConstCode from "../ConstCode";
import ConstData from "../ConstData";

import { enWebPage } from "../ConstCommand";
import { decodingPacket, getSendToMQBytes } from "../classTalk/EncodeDecode";
import { enTokenCMD, enTabStatus, ctRcvKind, enP2PMode } from "../classTalk/CodeEnum";
import { checkDownloadableUrl, checkUrlText, downloadFileUtil, getUrlText, isNotEmptyStr, isValidArray, isWindowsWebView } from "../func/ExportFunction";
import { getReplacedRoutingKeyForMixedClass } from "./rbmqKey";

import {
    forceLogOutInit,
    mqUpdateInfo,
    mixedClassLoginSuccess,
    mixedClassLogoutSuccess
} from "../../modules/user";

import {
    mqLoginChat,
    mqLogoutChat,
    mqJoinChat,
    mqFinishChat,
    mqExitChat,
    mqCreateChat,
    mqRemoveChat,
    mqRemoveChatMember,
    mqRemovedChatMember,
    mqUpdateChat,
    mqNameUpdateChat,
    mqModeUpdateChat,
    mqTypeUpdateChat,
    mqInviteChatMember,
    mqAddChatMember,
    mqUpdateChatMemberInfo
} from "../../modules/chat";

import {
    mqLoginFriend,
    mqLogoutFriend,
    mqCancelFriend,
    mqCancelFriendMe,
    mqRejectFriendMe,
    mqRejectFriend,
    mqRemoveFriend,
    mqAddFriend,
    mqMultipleAddFriend,
    mqApplyFriend,
    mqSendApplyFriend,
    mqMultipleApplyFriend,
    mqUpdateFriendStatus,
    mqUpdateFriendInfo
} from "../../modules/friend";

import {
    mqLiveOn,
    mqLiveOff,
    mqJoinLive,
    mqExitLive,
    mqCreateLive,
    mqRemoveLive,
    mqEditLiveName,
    mqRejectLiveMember,
    mqRejectedLiveMember,
    mqRemoveLiveMember,
    mqRemovedLiveMember,
    mqApplyLive,
    mqApproveLive,
    mqApproveLiveMember,
    mqAddLiveMember,
    mqHandsUpOn,
    mqHandsUpOff,
    mqHandsUpStart,
    mqHandsUpStop,
    mqHandsUpActive,
    mqHandsUpInactive,
    mqSmallGroupStart,
    mqSmallGroupStop,
    mqLiveInfoInit,
    mqBroadcastOn,
    mqBroadcastOff,
    mqUpdateBroadcastDate,
    mqChattingLock,
    mqTouchScreenLock,
    mqUpdateLiveMemberInfo,
    mqUpdateLiveMemberNickname,
    mqRcvSmartTVBindInfo,
    mqStartMixedClass,
    mqStopMixedClass,
    joinMixedClassLive,
    finishMixedClassLive,
    updateMixedClassMemberList,
    toggleLivePullScreenAlert,
    toggleIntensiveControlMode,
} from "../../modules/live";

import {
    mqDrawInkStrokeDown,
    mqDrawInkStrokeMove,
    mqDrawInkStrokeDoubleMove,
    mqDrawInkStrokeUp,
    mqDrawInkStroke,
    mqDrawInkStrokes,
    mqClearInkStroke,
    mqEraseInkStroke,
    mqChangeInkAttr,
    mqChangeInkMode,
    mqChangeInkColor,
    mqChangeInkTipSize,
    mqClearPage,
    mqRcvGroupChatList,
    closeWhisperModal,
    androidPenDown,
    androidPenMove,
    androidPenDoubleMove,
    androidPenUp,
    appendReceiveMessage,
    removeMixedFilePreparing,
    toggleFileShareMessage,
} from "../../modules/classTalkLive";

import {
    updateContentSendStatus,
} from "../../modules/classTalk";

import {
    mqUpdateStudioUser,
    mqUpdateStudioLive,
    mqUpdateDisplayStatus
} from "../../modules/studio";

import {
    mqRcvQuiz,
    mqRcvResponseFinishQuiz
} from "../../modules/quiz";

import {
    setSmartTVGroupListMember
} from "../../modules/hiclasstv";

import {
    mqRcvRemoteForwardResult,
    mqRcvLocalServerCommandAck
} from "../../modules/admin";

import {
    initHandsUpAudioConsume,
    startHandsUpAudioConsume,
    stopHandsUpAudioConsume,
    setHandsUpMicOn,
    setHandsUpMicOff,
    setHandsUpMicEnable,
    setHandsUpMicDisable,
    // setHandsUpSoundMuteMode,
    // setHandsUpSoundListenMode,
    handleHandsUpP2PMode_new,
    restartHandsUpP2PMode,
    handleHandsUpSmartTVMode,
    handleGroupStudyMode,
    updateSmallGroupImage,
    androidHandsUpInitDone,
    getIsAndroidDevice,
    getIsForPblModeBrowser,
    setConfigFPS,
    setScreenModeImage,
    clearTimerProc,
    setUpVideoStream,
    initHandsUpMic,
    sendMicStatus,
    isAndroidWebView,
    isIOSWebView,
    getAudioSourceSettings,
    setAudioSourceSettings,
} from "../HandsUpClient";

import {
    createConsumerTransportAfter,
    connectConsumerTransportAfter,
    restartConsumerTransportAfter,
    joinConsumeAfter,
    exitConsumeAfter,
    consumeAfter,
    resumeAfter,
    unsubscribeAfter,
    newProducerAfter,
    closeProducerAfter,
    createProducerTransportAfter,
    connectProducerTransportAfter,
    restartProducerTransportAfter,
    produceAfter,
    unpublishAfter,
    getStateAfter,
    displayRotationChangedAfter, // 260916 화면 보정 기능: 이미 송출 중인 producer의 회전값 변경 push 수신
    setPblStudentAudioListen, // 20260928 오디오 관련 설정 변경: PBL 학생 단말기의 그룹 오디오 재생 제어
} from "../MediaSoupClient";

import {
    alertErrMsg,
    setImageSrc,
    getRcvKind,
    getMyUserSeq,
    getRcvLiveSeq,
    getProfileImgUrl,
    getScreenImgStream,
    getRcvWhisperChat,
    getMyRoutingKey,
    getMyHandsUpSendKey,
    getMySmallGroupImageSendKey,
    getCurrentPageType,
    getSmartTVListMember,
    getIndexForGroupSmartTV,
    getConnectedOnScreenAppInfo,
    getConnectedOnScreenAppInfoWithIndex,
    getIsSmartTVMode,
    getIsRunForSmartPen,
    setIsRunForSmartPen,
    getIsAlivePenCamService,
    setIsAlivePenCamService,
    getIsClickConnAppBtn,
    setIsClickConnAppBtn,
    convertArrayBuffer,
    subscribeSmallGroup,
    unsubscribeSmallGroup,
    xmitCmd_AndroidInitDone,
    xmitCmd_AndroidStatusMessage,
    xmitCmd_MessageForSmartTV,
    xmitCmd_IosMessage,
    sendPageGetArtifactsForAndroid,
    sendUserLoginStatus,
    getIsHandsUpStarted,
    getIsActiveHandsUp,
    sendJsonData,
    sendP2PSoundOn,
    sendP2PSoundOff
} from "../RabbitmqClient";

import {
    rcvChatFileShareHelper,
    rcvChatTextHelper,
    rcvRawDataWithRoutingKeyHelper
} from "../helper/rbmq/RbmqPblRcvHelper";
import { runLiveConsumeAfter } from "../helper/LiveConsumeGuard"; // 20261028 consume 응답 처리 완료 후 대기 해제 (web-relay R-207)
import { isStaleLiveSendResponse } from "../MediaSoupClient"; // 20261028 송출 응답 수신 입구 판정 (web-relay R-224)

const clientInfo = {
    funcProc: null,
    funcProcArr: [
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },
        { userSeq: -1, funcProc: null },    // max value is 9
    ],
    smartTVUserScreenMaxProc : null,
    classMonitorGroupResetProc: null, // 260728 ClassMonitor만 무중단 그룹 갱신 콜백을 사용한다.
    classMonitorUserScreenModeProc: null, // 260803 학생의 JSON 요청으로 ClassMonitor 최대화/최소화를 처리한다.
    classMonitorScreenStateProc: null, // 260803 ClassMonitor의 현재 확대 학생을 학생 버튼 상태에 반영한다.
    classMonitorNicknameProc: null, // 260728 학생의 현재 로그인 닉네임을 ClassMonitor 타일에 즉시 반영한다.
    classMonitorLiveOffProc: null, // 260729 클래스 종료 시 ClassMonitor 로그인 화면 복귀를 알린다.
};

/**
 * 20261001 일반 Pro 교사의 소리 입력 설정 요청을 Android native Bridge에 전달하고 실제 결과만 반환한다.
 * 기존 화면 공유·P2P·producer는 재생성하지 않는다.
 */
const requestAndroidAudioSourceSettingsFromTeacher = (information) => new Promise((resolve) => {
    const requestId = information?.requestId;
    const processComm = window.ProcessComm;
    if (!requestId || !processComm || typeof processComm.requestAudioSourceSettings !== "function") {
        resolve({
            success: false,
            reason: "android_audio_source_settings_not_supported",
            supportedSources: [],
            clientKind: "android"
        });
        return;
    }

    let timeoutId = null;
    const handleResult = (event) => {
        const result = event.detail || {};
        if (result.requestId !== requestId) return;
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        if (timeoutId) window.clearTimeout(timeoutId);
        resolve({ ...result, clientKind: result.clientKind || "android" });
    };

    window.addEventListener("handsUpAudioSourceSettingsResult", handleResult);
    timeoutId = window.setTimeout(() => {
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        resolve({
            success: false,
            reason: "android_audio_source_settings_timeout",
            supportedSources: [],
            clientKind: "android"
        });
    }, 3000);

    try {
        processComm.requestAudioSourceSettings(JSON.stringify(information));
    } catch (error) {
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        window.clearTimeout(timeoutId);
        resolve({
            success: false,
            reason: "android_audio_source_settings_request_failed",
            supportedSources: [],
            clientKind: "android"
        });
    }
});

/**
 * 261015 iOS 앱에 소리 설정(get/set)을 요청하고 같은 requestId 결과만 반환한다.
 * 앱 회신: handleiOSScreenShareMessage("pro-audioSourceSettingsResult") → handsUpAudioSourceSettingsResult 이벤트
 */
const requestIOSAudioSourceSettingsFromTeacher = (information) => new Promise((resolve) => {
    const requestId = information?.requestId;
    const handler = window.webkit?.messageHandlers?.screenShareHandler;
    if (!requestId || !handler) {
        resolve({ success: false, reason: "ios_audio_source_settings_not_supported", supportedSources: [], clientKind: "ios" });
        return;
    }

    let timeoutId = null;
    const handleResult = (event) => {
        const result = event.detail || {};
        if (result.requestId !== requestId) return;
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        if (timeoutId) window.clearTimeout(timeoutId);
        resolve({ ...result, clientKind: result.clientKind || "ios" });
    };

    window.addEventListener("handsUpAudioSourceSettingsResult", handleResult);
    timeoutId = window.setTimeout(() => {
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        resolve({ success: false, reason: "ios_audio_source_settings_timeout", supportedSources: [], clientKind: "ios" });
    }, 3000);

    try {
        handler.postMessage({ action: "pro-audioSourceSettings", data: information });
    } catch (error) {
        window.removeEventListener("handsUpAudioSourceSettingsResult", handleResult);
        window.clearTimeout(timeoutId);
        resolve({ success: false, reason: "ios_audio_source_settings_request_failed", supportedSources: [], clientKind: "ios" });
    }
});

/**
 * 20261001 일반 Pro 학생이 교사 요청을 실제 단말 설정에 적용한 뒤 동일 requestId로 결과를 회신한다.
 * iOS native Bridge 적용은 담당자 구현 전까지 미지원 결과만 회신하며 기존 isMicOn은 변경하지 않는다.
 */
const processHandsUpAudioSourceSettings = async (information = {}) => {
    const { operation, requestId } = information;
    let result;

    if (operation !== "get" && operation !== "set") {
        result = { success: false, reason: "invalid_audio_source_settings_operation", supportedSources: [] };
    } else if (isIOSWebView()) {
        // 261015 iOS는 앱(ProAudioMixDevice)에 적용을 요청하고 실제 결과만 회신한다.
        // (보통은 앱이 RBMQ에서 직접 처리·회신하므로 여기까지 오지 않고, 앱에 회신 키가 없을 때만 이 경로를 탄다)
        if (window.isIOSNativeAudioSourceSupported === true) {
            result = await requestIOSAudioSourceSettingsFromTeacher(information);
        } else {
            // [261015-IOS-COMPAT] 하위호환: 소리 설정 미지원(이전) 앱은 기존과 동일하게 즉시 미지원 회신.
            // 모든 사용자가 새 앱으로 업데이트되면 이 else 블록과 위 if 조건을 제거.
            result = {
                success: false,
                reason: "ios_native_not_implemented",
                supportedSources: ["microphone"],
                clientKind: "ios"
            };
        }
    } else if (isAndroidWebView()) {
        result = await requestAndroidAudioSourceSettingsFromTeacher(information);
    } else if (operation === "get") {
        result = { success: true, ...getAudioSourceSettings(), clientKind: "pc", reason: "" };
    } else {
        const settings = {};
        if (typeof information.microphoneIncluded === "boolean") settings.microphoneIncluded = information.microphoneIncluded;
        if (typeof information.systemAudioIncluded === "boolean") settings.systemAudioIncluded = information.systemAudioIncluded;
        result = { ...setAudioSourceSettings(settings), clientKind: "pc" };
    }

    const store = window.hiclasstv.store;
    const { user } = store.getState();
    const response = {
        kind: "handsup",
        action: "audioSourceSettingsResult",
        information: {
            userSeq: user.userSeq,
            requestId: requestId || "",
            success: result.success === true,
            microphoneIncluded: result.microphoneIncluded,
            systemAudioIncluded: result.systemAudioIncluded,
            supportedSources: result.supportedSources || [],
            reason: result.reason || "",
            clientKind: result.clientKind || "pc"
        }
    };

    // 20261001 교사 요청으로 바뀐 실제 적용값을 열린 학생 소리 설정 패널에도 즉시 반영한다.
    window.dispatchEvent(new CustomEvent("handsUpAudioSourceSettingsApplied", {
        detail: { ...response.information, origin: "teacher" }
    }));
    console.log("[HandsUpAudioSourceSettings] response => ", response);
    sendJsonData(response, user.userNickname);
};

export const initFuncProc = (imageProcess) => {
    clientInfo.funcProc = imageProcess;
}

export const initFuncProcArr = (idx, userSeq, imageProcess) => {
    // console.log(`initFuncProcArr - idx[${idx}], userSeq[${userSeq}]`);
    if (getCurrentPageType() === enWebPage.GroupSmartTV || getCurrentPageType() === enWebPage.ClassMonitor) {
        // 260728 ClassMonitor는 최대 39명 상태 콜백을 사용하므로 기존 SmartTV 9칸 배열만 동적으로 확장한다.
        while (getCurrentPageType() === enWebPage.ClassMonitor && idx >= clientInfo.funcProcArr.length) {
            clientInfo.funcProcArr.push({ userSeq: -1, funcProc: null });
        }
        if (idx < clientInfo.funcProcArr.length) {
            clientInfo.funcProcArr[idx].userSeq = userSeq;
            clientInfo.funcProcArr[idx].funcProc = imageProcess;
        } else {
            clientInfo.funcProcArr.push({
                userSeq,
                funcProc: imageProcess
            });
        }
    } else {
        clientInfo.funcProc = imageProcess;
    }
}

export const initSmartTVUserScreenMaxProc = (proc) =>{
    clientInfo.smartTVUserScreenMaxProc = proc;
}

// 260728 기존 GroupSmartTV reload 동작과 분리한 ClassMonitor 그룹 갱신 콜백이다.
export const initClassMonitorGroupResetProc = proc => {
    clientInfo.classMonitorGroupResetProc = proc;
}

// 260728 ClassMonitor 전용 학생 최대화 콜백으로 기존 GroupSmartTV 화면 전환과 분리한다.
export const initClassMonitorUserScreenModeProc = proc => {
    clientInfo.classMonitorUserScreenModeProc = proc;
}

// 260803 ClassMonitor가 회신한 화면 상태 JSON을 학생 화면에 전달한다.
export const initClassMonitorScreenStateProc = proc => {
    clientInfo.classMonitorScreenStateProc = proc;
}

// 260728 기존 라이브 닉네임 갱신 메시지를 ClassMonitor 전용 상태에도 전달한다.
export const initClassMonitorNicknameProc = proc => {
    clientInfo.classMonitorNicknameProc = proc;
}

// 260729 기존 SmartTV와 동일한 LIVE_OFF 신호를 ClassMonitor 페이지에 전달한다.
export const initClassMonitorLiveOffProc = proc => {
    clientInfo.classMonitorLiveOffProc = proc;
}

export const getCurrentFuncProc = (userSeq, status, data) => {
    // console.log(`getCurrentFuncProc - userSeq[${userSeq}], status[${status}], data => `, data);
    if (getCurrentPageType() === enWebPage.GroupSmartTV || getCurrentPageType() === enWebPage.ClassMonitor) {
        const funcProcInfo = clientInfo.funcProcArr.find(info => info.userSeq === userSeq);
        // console.log(`getCurrentFuncProc - userSeq[${userSeq}], funcProcInfo => `, funcProcInfo);
        return funcProcInfo;
    } else {
        return clientInfo.funcProc;
    }
}

export const callCurrentFuncProc = (userSeq, status, data) => {
    // console.log(`getCurrentFuncProc - userSeq[${userSeq}], status[${status}], data => `, data);
    if (getCurrentPageType() === enWebPage.GroupSmartTV || getCurrentPageType() === enWebPage.ClassMonitor) {
        const funcProcInfo = clientInfo.funcProcArr.find(info => info.userSeq === userSeq);
        // console.log(`getCurrentFuncProc - userSeq[${userSeq}], funcProcInfo => `, funcProcInfo);
        if (funcProcInfo) {
            console.log(`getCurrentFuncProc - userSeq[${userSeq}], call funcProcInfo.funcProc(status[${status}], data[`, data, `])`);
            funcProcInfo.funcProc(status, data);
        }
    } else {
        if (clientInfo.funcProc) {
            console.log(`getCurrentFuncProc - userSeq[${userSeq}], call clientInfo.funcProc(status[${status}], data[`, data, `])`);
            clientInfo.funcProc(status, data);
        }
    }
}

const drawInkStrokeDown = (cmd, point) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqDrawInkStrokeDown({ cmd, point }));
}

const drawInkStrokeMove = (cmd, point) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqDrawInkStrokeMove({ cmd, point }));
}

const drawInkStrokeDoubleMove = (cmd, spoint, epoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqDrawInkStrokeDoubleMove({ cmd, spoint, epoint }));
}

const drawInkStrokeUp = (cmd, point) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqDrawInkStrokeUp({ cmd, point }));
}

const drawInkStroke = (stroke) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqDrawInkStroke({ stroke }));
}

const drawInkStrokes = (strokes, routingKey) => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    let performLiveSeq = performLiveInfo.liveSeq;

    if (performLiveSeq > 0) {
        let rcvLiveSeq = getRcvLiveSeq(routingKey);
        if (rcvLiveSeq === 0 || rcvLiveSeq === performLiveSeq) {
            // let store = window.hiclasstv.store;
            store.dispatch(mqDrawInkStrokes({ strokes }));
        }
    }
}

const clearInkStroke = (routingKey) => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    let performLiveSeq = performLiveInfo.liveSeq;

    if (performLiveSeq > 0) {
        let rcvLiveSeq = getRcvLiveSeq(routingKey);
        if (rcvLiveSeq === 0 || rcvLiveSeq === performLiveSeq) {
            // let store = window.hiclasstv.store;
            store.dispatch(mqClearInkStroke());
        }
    }
}

const eraseInkStroke = (cmd, spoint, epoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqEraseInkStroke({ cmd, spoint, epoint }));
}

const changeInkAttribute = (mode, r, g, b, width, height) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqChangeInkAttr({ mode, r, g, b, width, height }));
}

const changeInkMode = (mode) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqChangeInkMode({ mode }));
}

const changeInkColor = (r, g, b) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqChangeInkColor({ r, g, b }));
}

const changeInkTipSize = (width, height) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqChangeInkTipSize({ width, height }));
}

const rcvClearPage = (cmd) => {
    let store = window.hiclasstv.store;
    store.dispatch(mqClearPage({ cmd }));
}

const rcvAndroidPenDown = (cmd, spoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(androidPenDown({ cmd, point: spoint }));
}

const rcvAndroidPenMove = (cmd, spoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(androidPenMove({ cmd, point: spoint }));
}

const rcvAndroidPenDoubleMove = (cmd, spoint, epoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(androidPenDoubleMove({ cmd, point1: spoint, point2: epoint }));
}

const rcvAndroidPenUp = (cmd, spoint) => {
    let store = window.hiclasstv.store;
    store.dispatch(androidPenUp({ cmd, point: spoint }));
}

const normalizeBoolean = (value, defaultValue = false) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
        const normalized = value.toLowerCase();
        if (normalized === "y" || normalized === "yes" || normalized === "true" || normalized === "1") return true;
        if (normalized === "n" || normalized === "no" || normalized === "false" || normalized === "0") return false;
    }

    return defaultValue;
}

const convertHttpsDownloadUrlForPbl = (downloadUrl) => {
    try {
        const urlInfo = new URL(downloadUrl);
        if (urlInfo.protocol !== "https:") return downloadUrl;

        return `http://${urlInfo.hostname}:8080${urlInfo.pathname}${urlInfo.search}${urlInfo.hash}`;
    } catch (err) {
        console.log("convertHttpsDownloadUrlForPbl - invalid url => ", downloadUrl, err);
        return downloadUrl;
    }
}

const getIntensiveControlResponseAction = (routingKey) => {
    return routingKey && getRcvWhisperChat(routingKey) ? "whisper-intensiveControl" : "intensiveControl";
}

/**
 * 전달받은 텍스트 메시지를 귓속말/전체 메시지 여부에 따라
 * classTalk/classTalkLive에 말풍선으로 추가하는 함수.
 *
 * @param {String} userName - 메시지를 보낸 사람의 닉네임
 * @param {Number} emoGIDno - 이모티콘 그룹 번호 (고정값 0)
 * @param {Number} emoMIDno - 이모티콘 멤버 번호 (-1: 이모티콘 없음)
 * @param {String} msgText - 전송된 텍스트 메시지
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {Object} [contentInfo=null] - 컨텐츠 정보 (contentInfo: { contentSeq, refContentSeq, userSeq })
 *                                       전달되면 말풍선 추가 완료 후 'executed' ack 전송 ... by hjkim 20260615
 * @param {String} [kind="intensiveControl"] - ack 전송 시 사용할 kind 값 (기본값: "intensiveControl")
 */
const rcvChatText = (userName, emoGIDno, emoMIDno, msgText, routingKey, contentInfo = null, kind = "intensiveControl", forceWhisper = undefined) => {
    let store = window.hiclasstv.store;

    let selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    let profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
    let isUrlText = checkUrlText(msgText);
    let urlText = "";
    if (isUrlText) urlText = getUrlText(msgText);   // urlText 값 설정 누락 수정 ... by hjkim 20260107

    // 20260916 응답을 먼저 전송한 후 메시지를 표시하도록 수정
    // ── [핵심 추가 부분] 말풍선 추가(= 실행 완료) 후 'executed' ack 전송 ──────────
    // rcvChatFile은 다운로드 완료(비동기) 콜백 안에서 ack를 보내지만,
    // 텍스트 메시지는 appendReceiveMessage dispatch가 동기적으로 끝나므로
    // 말풍선 추가 직후(= 위 분기 처리가 끝난 직후) 바로 ack를 전송함
    if (contentInfo && contentInfo.contentSeq) {
        const { contentSeq, refContentSeq, userSeq } = contentInfo;

        // ※ 여기서 가져오는 userNickname은 메시지를 보낸 사람(userName)이 아닌,
        //   ack를 전송하는 주체인 '현재(수신측) 사용자' 자신의 닉네임임
        //   (rcvChatFile의 ack 전송부와 동일한 패턴) ... by hjkim 20260615
        const { user } = store.getState();
        const { userNickname } = user;

        const ackData = {
            kind: "live",
            action: kind,
            information: {
                kind: "content-send-ack",
                contentType: "message",
                contentSeq,
                refContentSeq,
                userSeq,
                status: "executed",     // 말풍선 추가 완료 = 실행 완료
            }
        };

        console.log("rcvChatText - contentSeq ack 전송, contentSeq => ", contentSeq);
        sendJsonData(ackData, userNickname);
    }

    // const rKeyArr = routingKey.split(".");
    // forceWhisper: content-send(intensiveControl) 계열 호출에서, routingKey의 whisper 여부와 무관하게
    // 귓속말/일반 여부를 명시적으로 강제하기 위한 옵션 (true=귓속말 강제, false=일반 강제, undefined=기존처럼
    // routingKey 기반 getRcvWhisperChat으로 자동 판단) ... by ri 20260710
    const isWhisperMsg = typeof forceWhisper === "boolean" ? forceWhisper : getRcvWhisperChat(routingKey);
    if (isWhisperMsg) {    // 귓속말 메시지인지 여부 메서드 호출 방식으로 수정 ... by hjkim 20260107
        let msgInfo = {
            kind: "whisper",
            iconSeq: parseInt(profileImgUrl),
            rcvKind: selRcvKind,
            rcvName: userName,
            text: "귓속말을 보냈습니다.",
            emoticSeq: -1,
            urlInfo: { text: msgText, emoticSeq: emoMIDno, isUrlText, urlText },
            isUrlText,
            urlText
        };

        store.dispatch(appendReceiveMessage(msgInfo));
    } else {                        // entire key (전체에게)
        let msgInfo = {
            iconSeq: parseInt(profileImgUrl),
            rcvKind: selRcvKind,
            rcvName: userName,
            text: msgText,
            emoticSeq: emoMIDno,
            urlInfo: "",
            isUrlText,
            urlText
        };

        store.dispatch(appendReceiveMessage(msgInfo));
    }
}

const rcvChatAudioMemo = (voiceData, userName, routingKey) => {
    let store = window.hiclasstv.store;
    let selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    let profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
    let blob = new Blob([voiceData], { type: "audio/mp3" });
    let voiceUrl;

    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
        voiceUrl = reader.result;

        // const rKeyArr = routingKey.split(".");
        if (getRcvWhisperChat(routingKey)) {    // 귓속말 메시지인지 여부 메서드 호출 방식으로 수정 ... by hjkim 20260107
            let msgInfo = {
                kind: "whisper",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                text: "귓속말을 보냈습니다.",
                // urlInfo: { text: "음성톡", kind: "audio_memo", urlInfo: voiceUrl },
                urlInfo: { text: "음성메모", kind: "audio_memo", urlInfo: voiceUrl },
            };

            store.dispatch(appendReceiveMessage(msgInfo));
        } else {                        // entire key (전체에게)
            let msgInfo = {
                kind: "audio_memo",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                // text: "음성톡",
                text: "음성메모",
                urlInfo: voiceUrl
            };

            store.dispatch(appendReceiveMessage(msgInfo));
        }
    };
}

const rcvChatInkMemo = (imgData, userName, routingKey) => {
    let store = window.hiclasstv.store;
    let selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    let profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
    let blob = new Blob([imgData], { type: "image/jpeg" });
    let imagUrl;

    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
        imagUrl = reader.result;

        // const rKeyArr = routingKey.split(".");
        if (getRcvWhisperChat(routingKey)) {    // 귓속말 메시지인지 여부 메서드 호출 방식으로 수정 ... by hjkim 20260107
            let msgInfo = {
                kind: "whisper",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                text: "귓속말을 보냈습니다.",
                // urlInfo: { text: "메모톡", kind: "ink_memo", urlInfo: imagUrl },
                urlInfo: { text: "잉크메모", kind: "ink_memo", urlInfo: imagUrl }
            };

            store.dispatch(appendReceiveMessage(msgInfo));
        } else {
            let msgInfo = {
                kind: "ink_memo",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                // text: "메모톡",
                text: "잉크메모",
                urlInfo: imagUrl
            };

            store.dispatch(appendReceiveMessage(msgInfo));
        }
    };
}

/**
 * 전달받은 업로드된 파일의 URL PATH를 믹스드 클래스 멤버인지 여부에 따라
 * 변환 후 classTalk/classTalkLive에 저장하는 함수.
 * 
 * @param {String} path - 업로드된 파일의 URL Path
 * @param {String} userName - 사용자 닉네임
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {String} [originalFileName=null] - 업로드된 파일의 원본 파일 이름 (기본값: null)
 * @param {String} [fileTransferType="file-transfer"] - 파일 전송/파일 공유 구분값. "file-transfer"는 학생 말풍선에 다운로드 버튼 UI를 표시하고, "file-share"는 다운로드 버튼 UI를 표시하지 않는다.
 * @param {Boolean|String} [isAutoDownloadAllowed=false] - 자동 다운로드 허용 여부. true/Y/yes/1이면 말풍선 생성 후 기존 로직처럼 파일을 자동 다운로드하고, false/N/no/0이면 자동 다운로드하지 않는다.
 * @param {Boolean} [isOverwriteAllowed=false] - 기존 파일 덮어쓰기를 허용할지 여부 (기본값: false)
 * @param {Boolean} [executeYn="N"] - 파일을 실행할지 여부 (기본값: "N")
 * @param {Object} [contentInfo=null] - 컨텐츠 정보 (contentInfo: { contentSeq, contentTeacherSeq, refContentSeq, userSeq })
 * @param {String} [kind="intensiveControl"] - ack 전송 시 사용할 kind 값 (기본값: "intensiveControl")
 */
const rcvChatFile = (path, userName, routingKey, originalFileName = null, fileTransferType = "file-transfer", isAutoDownloadAllowed = false, isOverwriteAllowed = false, executeYn = "N", contentInfo = null, kind = "intensiveControl", forceWhisper = undefined, mixedClassTransferId = null) => {
    try {
        const isPblModeBrowser = getIsForPblModeBrowser();
        // 20260708 ... pbl 모드 브라우저인 경우, executeYn 기준으로 file-share/file-transfer 결정 ("Y" -> file-transfer, "N" -> file-share) ... by ri
        const normalizedFileTransferType = isPblModeBrowser
            ? (executeYn === "Y" ? "file-transfer" : "file-share")
            : (fileTransferType || "file-transfer");
        const allowAutoDownload = isPblModeBrowser
            ? normalizedFileTransferType === "file-transfer"
            : normalizeBoolean(isAutoDownloadAllowed, false);
        const isDownloadButtonVisible = normalizedFileTransferType === "file-transfer";

        console.log("rcvChatFile - file transfer option debug => ", {
            isPblModeBrowser,
            executeYn,
            originalFileTransferType: fileTransferType,
            normalizedFileTransferType,
            originalIsAutoDownloadAllowed: isAutoDownloadAllowed,
            allowAutoDownload,
            isDownloadButtonVisible
        });

        if (!isNotEmptyStr(path)) {
            console.log("rcvChatFile - 전달받은 업로드 URL PATH가 존재하지 않음");
            console.log("userName => ", userName);
            console.log("path => ", path);
            return;
        }

        let downloadUrl = path;
        let store = window.hiclasstv.store;
        const { live } = store.getState();
        const { isMixedClassMember } = live;
        if (isMixedClassMember) {
            const { mixedClassInfo } = live;
            let localTeacherSeq = mixedClassInfo.localTeacherSeq;
            let localLiveSeq = mixedClassInfo.localLiveSeq;
            let serverTeacherSeq = mixedClassInfo.serverTeacherSeq;
            let serverLiveSeq = mixedClassInfo.serverLiveSeq;
            let serachValue;
            let replaceValue;
            const downloadUrlArr = downloadUrl.split("/");
            console.log("rcvChatFile - mixed class member, downloadUrlArr => ", downloadUrlArr);
            if (isValidArray(downloadUrlArr, 3, 4)) {
                if (downloadUrlArr.length === 4) {  // 학생이 보낸 파일인 케이스
                    // searchValue - [0]: 0, [1]: localTeacherSeq, [2]: localLiveSeq, [3]: filename
                    // replaceValue - [0]: 0, [1]: serverTeacherSeq, [2]: serverLiveSeq, [3]: filename
                    serachValue = `${downloadUrlArr[0]}/${localTeacherSeq}/${localLiveSeq}/`;
                    replaceValue = `${downloadUrlArr[0]}/${serverTeacherSeq}/${serverLiveSeq}/`;
                    console.log(`(1) before filePath => ${downloadUrl}`);
                    downloadUrl = downloadUrl.replace(serachValue, replaceValue);
                    console.log(`(1) after filePath => ${downloadUrl}`);
                } else { // 선생님이 보낸 파일인 케이스 (downloadUrlArr.length === 3)
                    // searchValue - [0]: 0, [1]: localTeacherSeq, [2]: filename
                    // replaceValue - [0]: 0, [1]: serverTeacherSeq, [2]: filename
                    serachValue = `${downloadUrlArr[0]}/${localTeacherSeq}/${downloadUrlArr[2]}`;
                    replaceValue = `${downloadUrlArr[0]}/${serverTeacherSeq}/${downloadUrlArr[2]}`;
                    console.log(`(2) before filePath => ${downloadUrl}`);
                    downloadUrl = downloadUrl.replace(serachValue, replaceValue);
                    console.log(`(2) after filePath => ${downloadUrl}`);
                }
            } else {
                console.log("(2) rcvChatFile - 이런 경우가 있나요?! downloadUrlArr => ", downloadUrlArr);
                return;
            }
        }

        if (!checkDownloadableUrl(downloadUrl)) {
            console.log("/download/ 포함되지 않은 url임 ... downloadUrl => ", downloadUrl);
            downloadUrl = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + downloadUrl;
        }
        if (isPblModeBrowser) {
            downloadUrl = convertHttpsDownloadUrlForPbl(downloadUrl);
        }

        console.log("final download url => ", downloadUrl);

        // 20260908 수정: 전용 다운로드 브리지가 있는 앱은 기존 버튼/메서드를 유지하고,
        // 일반 웹 브라우저만 사용자가 직접 누르는 링크를 말풍선에 표시한다.
        const useNativeDownloadButton = isAndroidWebView()
            || isIOSWebView()
            || isWindowsWebView()
            || isPblModeBrowser
            || !!(window.eoapi && typeof window.eoapi.extInvoke === "function");

        // 20260901 추가: 믹스드 클라우드 준비 알림은 실제 다운로드 파일이 도착한 시점에만 교체한다.
        if (mixedClassTransferId) store.dispatch(removeMixedFilePreparing({ mixedClassTransferId }));

        let selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
        let profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
        const sendFileUploadAck = (status, logMessage) => {
            // 20260908 수정: 첫 contentSeq가 0이어도 파일 수신 ACK를 전송한다.
            if (contentInfo && contentInfo.contentSeq !== undefined && contentInfo.contentSeq !== null && contentInfo.contentSeq !== "") {
                const { contentSeq, refContentSeq, userSeq } = contentInfo;
                const { user } = store.getState();
                const { userNickname } = user;

                const ackData = {
                    kind: "live",
                    action: kind,
                    information: {
                        kind: "content-send-ack",
                        contentType: "file-upload",
                        contentSeq,
                        refContentSeq,
                        userSeq,
                        status,
                    }
                };

                console.log(logMessage, contentSeq);
                sendJsonData(ackData, userNickname);
            }
        };

        // forceWhisper: content-send(intensiveControl) 계열 호출에서, routingKey의 whisper 여부와 무관하게
        // 귓속말/일반 여부를 명시적으로 강제하기 위한 옵션 (true=귓속말 강제, false=일반 강제, undefined=기존처럼
        // routingKey 기반 getRcvWhisperChat으로 자동 판단) ... by ri 20260710
        const isWhisperMsg = typeof forceWhisper === "boolean" ? forceWhisper : getRcvWhisperChat(routingKey);
        if (isWhisperMsg) {    // 귓속말 메시지인지 여부 메서드 호출 방식으로 수정 ... by hjkim 20260107
            let msgInfo = {
                kind: "whisper",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                text: "귓속말을 보냈습니다.",
                urlInfo: {
                    text: userName + "님이 파일을 전송했습니다.",
                    kind: "file_share",
                    urlInfo: downloadUrl,
                    originalFileName,
                    contentInfo,
                    executeYn,
                    fileTransferType: normalizedFileTransferType,
                    isAutoDownloadAllowed: allowAutoDownload,
                    isOverwriteAllowed,
                    contentKind: kind,
                    forceWhisper,
                    useNativeDownloadButton,
                    isClickedDownload: false
                }
            };

            store.dispatch(appendReceiveMessage(msgInfo));
            sendFileUploadAck("received", "rcvChatFile - contentSeq received ack send, contentSeq => ");

            // 귓속말 파일은 자동 다운로드 X
            // (귓속말은 수신자가 명시적으로 열어서 확인하는 것이 자연스러움)
        } else {
            let msgInfo = {
                kind: "file_share",
                iconSeq: parseInt(profileImgUrl),
                rcvKind: selRcvKind,
                rcvName: userName,
                text: userName + "님이 파일을 전송했습니다.",
                urlInfo: downloadUrl,
                originalFileName,
                isOverwriteAllowed,
                isClickedDownload: false,
                isDownloadButtonVisible,
                isAutoDownloadAllowed: allowAutoDownload,
                fileTransferType: normalizedFileTransferType,
                contentInfo,
                executeYn,
                contentKind: kind,
                forceWhisper,
                useNativeDownloadButton
            };

            store.dispatch(appendReceiveMessage(msgInfo));
            sendFileUploadAck("received", "rcvChatFile - contentSeq received ack send, contentSeq => ");

            // ── [핵심 추가 부분] 메시지 수신 즉시 자동 다운로드 시작 ──────────
            // idx는 Redux에서 새로 추가된 메시지의 인덱스가 필요하므로
            // dispatch 직후 현재 메시지 배열 길이에서 추출
            const { classTalkLive } = store.getState();
            // 방금 추가된 메시지가 배열의 마지막 항목이므로 length - 1이 해당 idx
            const newMsgIdx = classTalkLive.receivedMsg.length - 1;
            if (!allowAutoDownload) {
                console.log("rcvChatFile - auto download is not allowed");
                return;
            }

            console.log("rcvChatFile - 자동 다운로드 시작, idx => ", newMsgIdx);

            // downloadFileUtil: fetch → Blob → <a>.click() 자동 실행
            // 완료 콜백에서 해당 메시지의 isClickedDownload를 true로 변경
            if (isPblModeBrowser) {
                console.log("rcvChatFile - PBL 모드에서는 자동 다운로드를 수행하지 않음");
                return;
            }

            /* 기존 자동 다운로드 호출(보존)
            downloadFileUtil(
                downloadUrl,
                originalFileName,
                isOverwriteAllowed,
                executeYn,
                contentInfo,
                newMsgIdx,
                (downloadedIdx) => {
                    store.dispatch(
                        toggleFileShareMessage({ idx: downloadedIdx, isClickedBtn: true })
                    );

                    sendFileUploadAck("downloaded", "rcvChatFile - contentSeq downloaded ack send, contentSeq => ");
                },
                kind
            );
            */

            downloadFileUtil(
                downloadUrl,
                originalFileName,
                isOverwriteAllowed,
                executeYn,
                contentInfo,
                newMsgIdx,
                (downloadedIdx) => {
                    // Redux: 해당 메시지의 다운로드 완료 상태 업데이트
                    store.dispatch(
                        toggleFileShareMessage({ idx: downloadedIdx, isClickedBtn: true })
                    );

                    sendFileUploadAck("downloaded", "rcvChatFile - contentSeq downloaded ack send, contentSeq => ");
                },
                kind
            );
            // ※ await 하지 않음: 다운로드가 비동기로 진행되는 동안 UI 흐름은 차단하지 않음
        }
    } catch (err) {
        console.log("rcvChatFile - err => ", err);
    }
}

const rcvCmd_PagePut = (imgData, routingKey) => {
    // console.log("rcvCmd_PagePut - ", imgData, routingKey);
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    let performLiveSeq = performLiveInfo.liveSeq;

    if (performLiveSeq > 0) {
        let rcvLiveSeq = getRcvLiveSeq(routingKey);
        if (rcvLiveSeq === 0 || rcvLiveSeq === performLiveSeq) {
            let blob = new Blob([imgData], { type: "image/jpeg" });
            let imageUrl;
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => {
                imageUrl = reader.result;
                let img = document.createElement("img");
                let canvas = document.getElementById("rcvDrawImgCanvas");
                img.src = imageUrl;
                img.onload = () => {
                    setImageSrc(img);
                };
            };
        }
    }
}

const rcvCmd_PageGet = (action, tokenCmd) => {
    let agent = navigator.userAgent.toLowerCase();

    if (agent.indexOf("android") !== -1) {
        if (isAndroidWebView()) {
            sendPageGetArtifactsForAndroid(action, tokenCmd);
        } else { // app과 연결되지 않았을경우 android 임시로 ios와 같은 방식으로 처리하도록 ...
            html2canvas(document.body)
            .then((data) => {
                data.toBlob((blob) => {
                    convertArrayBuffer(tokenCmd, blob);
                    let store = window.hiclasstv.store;
                    store.dispatch(toggleLivePullScreenAlert({ isModalOpened: true }));
                }, "image/jpeg"/*, 1.0*/);
            })
            .catch((err) => {
                console.log("rcvCmd_PageGet(1) html2canvas err ", err);
            });
        }
    } else if (agent.indexOf("iphone") !== -1 || agent.indexOf("ipad") !== -1) {
        html2canvas(document.body)
        .then((data) => {
            data.toBlob((blob) => {
                convertArrayBuffer(tokenCmd, blob);
            }, "image/jpeg"/*, 1.0*/);
        })
        .catch((err) => {
            console.log("rcvCmd_PageGet(2) html2canvas err ", err);
        });
    } else {
        if (navigator.mediaDevices.getDisplayMedia) {
            navigator.mediaDevices.getDisplayMedia({ video: true })
            .then((stream) => {
                getScreenImgStream(tokenCmd, stream);
            })
            .catch((err) => {
                alertErrMsg(err);
            });
        } else {
            html2canvas(document.body)
            .then((data) => {
                data.toBlob((blob) => {
                    convertArrayBuffer(tokenCmd, blob);
                }, "image/jpeg"/*, 1.0*/);
            })
            .catch((err) => {
                console.log("rcvCmd_PageGet(3) html2canvas err ", err);
            });
        }
    }
}

const rcvCmd_TouchScreen = (liveSeq, userSeq, isTouchScreenLocked) => {
    console.log(`rcvCmd_TouchScreen - liveSeq[${liveSeq}] userSeq[${userSeq}] isTouchScreenLocked[${isTouchScreenLocked}]`);
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { isMixedClassMember, performLiveInfo } = live;
    console.log(`isMixedClassMember[${isMixedClassMember}], performLiveInfo => `, performLiveInfo);
    if (isMixedClassMember) { // mixed class 멤버인 경우
        const { mixedClassInfo } = live;
        console.log(`mixedClassInfo => `, mixedClassInfo);
        // 우선 mixed class local teacherSeq & local liveSeq 와 일치 여부 비교
        if (mixedClassInfo.localTeacherSeq === userSeq && (mixedClassInfo.localLiveSeq || liveSeq === -1)) {
            let performLiveSeq = performLiveInfo.liveSeq;
            let performLiveTeacherSeq = performLiveInfo.teacher_info.userSeq;

            // mixed class serverTeacherSeq & serverLiveSeq 와 perform teacherSeq & liveSeq 일치 여부 비교
            if (mixedClassInfo.serverTeacherSeq === performLiveTeacherSeq && mixedClassInfo.serverLiveSeq === performLiveSeq) {
                console.log("(1) getIsAndroidDevice => ", getIsAndroidDevice());
                if (!getIsAndroidDevice() && !isAndroidWebView()) { // ios case 는 없다고 가정 for PC
                    let touchLockGuard = document.getElementById("touchLockGuard");
                    console.log("(1) touchLockGuard => ", touchLockGuard);
                    if (touchLockGuard) {
                        if (isTouchScreenLocked) {
                            touchLockGuard.style.display = "flex";
                            touchLockGuard.style.visibility = "visible";
                            touchLockGuard.style.zIndex = 51;

                            if (isWindowsWebView()) {
                                console.log("(1-1) Pentalk Browser 접속 케이스");
                                window.chrome.webview.postMessage({ kind: "lock" });
                            }
                        } else {
                            touchLockGuard.style.display = "none";
                            touchLockGuard.style.visibility = "hidden";
                            touchLockGuard.style.zIndex = "unset";

                            if (isWindowsWebView()) {
                                console.log("(1-2) Pentalk Browser 접속 케이스");
                                window.chrome.webview.postMessage({ kind: "unlock" });
                            }
                        }
                    }
                } else {
                    console.log("(1) isAndroidWebView => " + isAndroidWebView());
                    if (isAndroidWebView()) {
                        if (isTouchScreenLocked) {
                            console.log("(1) call window.lockTouchScreen()");
                            window.lockTouchScreen();
                        } else {
                            console.log("(1) call window.unLockTouchScreen()");
                            window.unLockTouchScreen();
                        }
                    }
                }
            }
        }
    } else {
        // perform teacherSeq & liveSeq 일치 여부 비교
        if (performLiveInfo.teacher_info.userSeq === userSeq && (performLiveInfo.liveSeq === liveSeq || liveSeq === -1)) {
            console.log("(2) getIsAndroidDevice => ", getIsAndroidDevice());
            if (!getIsAndroidDevice() && !isAndroidWebView()) { // ios case 는 없다고 가정 for PC
                let touchLockGuard = document.getElementById("touchLockGuard");
                console.log("(2) touchLockGuard => ", touchLockGuard);
                if (touchLockGuard) {
                    if (isTouchScreenLocked) {
                        touchLockGuard.style.display = "flex";
                        touchLockGuard.style.visibility = "visible";
                        touchLockGuard.style.zIndex = 51;

                        if (isWindowsWebView()) {
                            console.log("(2-1) Pentalk Browser 접속 케이스");
                            window.chrome.webview.postMessage({ kind: "lock" });
                        }
                    } else {
                        touchLockGuard.style.display = "none";
                        touchLockGuard.style.visibility = "hidden";
                        touchLockGuard.style.zIndex = "unset";

                        if (isWindowsWebView()) {
                            console.log("(2-2) Pentalk Browser 접속 케이스");
                            window.chrome.webview.postMessage({ kind: "unlock" });
                        }
                    }
                }
            } else {
                console.log("(2) isAndroidWebView => " + isAndroidWebView());
                if (isAndroidWebView()) {
                    if (isTouchScreenLocked) {
                        console.log("(2) call window.lockTouchScreen()");
                        window.lockTouchScreen();
                    } else {
                        console.log("(2) call window.unLockTouchScreen()");
                        window.unLockTouchScreen();
                    }
                }
            }
        }
    }
}

export const rcvCmd_AndroidLogin = async (userSeq) => {
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        setIsAlivePenCamService(true);
        /* if (!getIsAvailableApp()) {
            console.log("Pentalk OnScreen 앱 설치 또는 앱에서 권한(접근성 등)을 얻는 동안 setTimeout Process에 의해 값이 변한 경우!!");
            initAvailableApp(); // 20241115 ... 앱 설치 또는 앱에서 권한(접근성 등)을 얻는 동안 값이 변하는 경우가 발생하기 때문에 다시 값을 초기화해야 한다... by hjkim
        } else {
            console.log("정상적으로 Pentalk OnScreen 앱과 연결된 경우!!");
        } */
        console.log("정상적으로 Pentalk OnScreen 앱과 연결된 경우!!");
        await clearTimerProc(true); // 20241226 ... 실행 중이던 timer를 취소해야함... by hjkim
        setScreenModeImage("connect"); // 20241128 ... 앱과 연결되면 appNotConnect 이미지가 appConnect 이미지로 바뀔 것이다 ... by hjkim
        // if (clientInfo.funcProc) clientInfo.funcProc("connected"); // 20250221 ... module에서 값 관리하도록 바꿔서 주석 처리함 ... by hjkim
        if (isAndroidWebView()) {
            window.callLoginResp(enTabStatus.Connected);
        } else {
            xmitCmd_AndroidStatusMessage("ct_LoginResp", enTokenCMD.ct_LoginResp, enTabStatus.Connected);
        }
    }
}

export const rcvCmd_AndroidLoginResp = async (userSeq) => {
    console.log("rcvCmd_AndroidLoginResp - userSeq => ", userSeq);
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        if (getIsRunForSmartPen() || getIsClickConnAppBtn()) {
            setIsRunForSmartPen(false);
            setIsClickConnAppBtn(false);
            // xmitCmd_AndroidInitDone(); // 20250107 ... 펜톡 모니터 화면 학생 로그아웃 표시 방지 ... by hjkim
            let store = window.hiclasstv.store;
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            console.log(`isMixedClassMember[${isMixedClassMember}]`);
            if (isMixedClassMember) { // mixed class 멤버인 경우
                const { mixedClassInfo, performLiveInfo } = live;
                console.log("mixedClassInfo => ", mixedClassInfo, ", performLiveInfo => ", performLiveInfo);
                if (performLiveInfo.liveSeq > 0) {
                    if (performLiveInfo.liveSeq === mixedClassInfo.serverLiveSeq) {
                        sendUserLoginStatus(mixedClassInfo.localLiveSeq, myUserSeq, ConstCode.LIVE_JOIN);
                        console.log("call xmitCmd_AndroidInitDone case 2");
                        xmitCmd_AndroidInitDone(); // 20260203 ... enProduceAfter에서만 호출되도록 수정
                        await clearTimerProc(true); // 20241226 ... 실행 중이던 timer를 취소해야함... by hjkim
                        setScreenModeImage("connect"); // 20241128 ... 앱과 연결되면 appNotConnect 이미지가 appConnect 이미지로 바뀔 것이다 ... by hjkim
                    } else {
                        console.log("rcvCmd_AndroidLoginResp- performLiveInfo.liveSeq !== mixedClassInfo.serverLiveSeq !! ", `performLiveInfo.liveSeq[${performLiveInfo.liveSeq}], mixedClassInfo.serverLiveSeq[${mixedClassInfo.serverLiveSeq}]`);
                    }
                } else {
                    console.log("(1) rcvCmd_AndroidLoginResp - performLiveInfo.liveSeq is => ", performLiveInfo.liveSeq);
                }
            } else {
                const { performLiveInfo } = live;
                console.log("performLiveInfo => ", performLiveInfo);
                if (performLiveInfo.liveSeq > 0) {
                    sendUserLoginStatus(performLiveInfo.liveSeq, myUserSeq, ConstCode.LIVE_JOIN);
                    console.log("call xmitCmd_AndroidInitDone case 3");
                    xmitCmd_AndroidInitDone(); // 20260203 ... enProduceAfter에서만 호출되도록 수정
                    await clearTimerProc(true); // 20241226 ... 실행 중이던 timer를 취소해야함... by hjkim
                    setScreenModeImage("connect"); // 20241128 ... 앱과 연결되면 appNotConnect 이미지가 appConnect 이미지로 바뀔 것이다 ... by hjkim
                } else {
                    console.log("(2) rcvCmd_AndroidLoginResp - performLiveInfo.liveSeq is => ", performLiveInfo.liveSeq);
                }
            }
        } else {
            /* if (getIsHandsUpStarted()) { // handsup이 시작했을 경우에만 앱 연동시 화면 캡쳐를 시작하도록 한다... by hjkim 20221025
                xmitCmd_AndroidMessage("ct_LiveOn", enTokenCMD.NULL); // test용 임시
                xmitCmd_AndroidMessage("ct_StartHandsUp", enTokenCMD.NULL); // test용 임시
                androidHandsUpInitDone();
                xmitCmd_AndroidTouchScreenLock(); // test용 임시
            } else {
                console.log("rcvCmd_AndroidLoginResp - handsup is not started ... ");
            } */
            console.log("call xmitCmd_AndroidInitDone case 1");
            xmitCmd_AndroidInitDone(); // 20260203 ... enProduceAfter에서만 호출되도록 수정
            console.log("rcvCmd_AndroidLoginResp - case 5:) call sendMicStatus()");
            sendMicStatus(); // 20251117 ... HANDS_UP_INIT_DONE 다음으로 순서 변경 ... by hjkim
            await clearTimerProc(true); // 20241226 ... 실행 중이던 timer를 취소해야함... by hjkim
            setScreenModeImage("connect"); // 20241128 ... 앱과 연결되면 appNotConnect 이미지가 appConnect 이미지로 바뀔 것이다 ... by hjkim
        }
    } else {
        console.log("rcvCmd_AndroidLoginResp case 4");
    }
}

export const rcvCmd_AndroidLogout = (userSeq) => {
    if (getCurrentPageType() === enWebPage.GroupSmartTV) {
        setIsAlivePenCamService(false, userSeq);
        let idx = getIndexForGroupSmartTV(userSeq);
        if (idx > -1) {
            if (clientInfo.funcProcArr) {
                let funcProc = clientInfo.funcProcArr[idx].funcProc;
                if (funcProc) {
                    funcProc("disconnect");
                }
            }
        } else {
            if (clientInfo.funcProc) clientInfo.funcProc("disconnect");
        }
    } else {
        let myUserSeq = getMyUserSeq();
        if (userSeq === myUserSeq) {
            if (getIsSmartTVMode()) {
                setIsAlivePenCamService(false, userSeq);
                if (clientInfo.funcProc) clientInfo.funcProc("disconnect");
            } else {
                setIsAlivePenCamService(false);
                // if (clientInfo.funcProc) clientInfo.funcProc("disconnected"); // 20250221 ... module에서 값 관리하도록 바꿔서 주석 처리함 ... by hjkim
            }
        }
    }
}

export const rcvCmd_AndroidLogoutResp = (userSeq) => {
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        /* if (getIsAlivePenCamService()) {
            setIsAlivePenCamService(false);
            // if (clientInfo.funcProc) clientInfo.funcProc("disconnected"); // 20250221 ... module에서 값 관리하도록 바꿔서 주석 처리함 ... by hjkim
        } */
    }
}

export const rcvCmd_AndroidReconnResp = (userSeq) => {
    console.log("rcvCmd_AndroidReconnResp - userSeq[" + userSeq + "]");
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        setIsAlivePenCamService(true);
        /* if (!getIsAvailableApp()) {
            console.log("Pentalk OnScreen 앱 설치 또는 앱에서 권한(접근성 등)을 얻는 동안 setTimeout Process에 의해 값이 변한 경우!!");
            initAvailableApp(); // 20241230 ... 앱 설치 또는 앱에서 권한(접근성 등)을 얻는 동안 값이 변하는 경우가 발생하기 때문에 다시 값을 초기화해야 한다... by hjkim
        } else {
            console.log("정상적으로 Pentalk OnScreen 앱과 연결된 경우!!");
        } */
        console.log("정상적으로 Pentalk OnScreen 앱과 연결된 경우!!");
        clearTimerProc(true); // 20241230 ... 실행 중이던 timer를 취소해야함... by hjkim
        console.log("call setScreenModeImage(connect).");
        setScreenModeImage("connect"); // 20241230 ... 앱과 연결되면 appNotConnect 이미지가 appConnect 이미지로 바뀔 것이다 ... by hjkim
        // if (clientInfo.funcProc) clientInfo.funcProc("connected"); // 20250221 ... module에서 값 관리하도록 바꿔서 주석 처리함 ... by hjkim
        androidHandsUpInitDone();
        console.log("rcvCmd_AndroidReconnResp - case 6:) call sendMicStatus()");
        sendMicStatus(); // 20251117 ... HANDS_UP_INIT_DONE 다음으로 순서 변경 ... by hjkim
    }
}

export const rcvCmd_AndroidCaptureStatus = async (action, userSeq, status) => {
    console.log("rcvCmd_AndroidCaptureStatus() - action: " + action + ", userSeq: " + userSeq + ", status: " + status);
    console.log("rcvCmd_AndroidCaptureStatus() - isHandsUpStarted: " + getIsHandsUpStarted() + ", isActiveHandsUp: " + getIsActiveHandsUp());
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        if (status) {
            setScreenModeImage("connect");
        } else {
            // 20260827 핸즈업 inactive 중 화면 공유 중지 응답으로 비디오 재송출이 시작되지 않도록 active 상태를 확인한다.
            if (getIsHandsUpStarted() && getIsActiveHandsUp()) { // 핸즈업이 시작된 경우에만 화면 공유 중단 → 카메라 영상 공유 시작 흐름 타도록 수정 ... by hjkim
                await initHandsUpMic(false);
                // window.isNeedCallSetUpVideoStream = true;
                setUpVideoStream(false);
            }
        }
    }
}

export const rcvCmd_AndroidMicStatus = (userSeq, status) => {
    console.log("rcvCmd_AndroidMicStatus() - userSeq: ", userSeq, ", status: ", status);
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq) {
        // 스크린 모드이고, 안드로이드 웹뷰거나 ios 웹뷰인 경우 여기서 sendP2PSoundOn/Off 하기 ... by hjkim 20260310
        let liveSeq = -1;
        let store = window.hiclasstv.store;
        const { live } = store.getState();
        const { isMixedClassMember, performLiveInfo } = live;
        console.log(`isMixedClassMember[${isMixedClassMember}]`);
        if (isMixedClassMember) { // mixed class 멤버인 경우
            const { mixedClassInfo, performLiveInfo } = live;
            if (performLiveInfo.liveSeq > 0) {
                if (performLiveInfo.liveSeq === mixedClassInfo.serverLiveSeq) {
                    liveSeq = mixedClassInfo.localLiveSeq;
                }
            }
        } else { // 일반 class 멤버인 경우
            if (performLiveInfo.liveSeq > 0) {
                liveSeq = performLiveInfo.liveSeq;
            }
        }

        console.log("rcvCmd_AndroidMicStatus() - liveSeq: ", liveSeq, ", userSeq: ", userSeq);

        // if (getIsAlivePenCamService()) {
            if (status) {
                // if (clientInfo.funcProc) clientInfo.funcProc("android_appMicOn");
                if (clientInfo.funcProc) clientInfo.funcProc("android_appMic", true);

                /* if (typeof liveSeq === "number" && liveSeq > -1) {
                    sendP2PSoundOn(liveSeq, userSeq);
                } */
            } else {
                // if (clientInfo.funcProc) clientInfo.funcProc("android_appMicOff");
                if (clientInfo.funcProc) clientInfo.funcProc("android_appMic", false);

                /* if (typeof liveSeq === "number" && liveSeq > -1) {
                    sendP2PSoundOff(liveSeq, userSeq);
                } */
            }
        // }
    }
}

const rcvCmd_AndroidSmartTVResponse = (userSeq) => {
    console.log(`rcvCmd_AndroidSmartTVResponse - userSeq[${userSeq}]`);
    if (getCurrentPageType() === enWebPage.GroupSmartTV) {
        if (!getIsAlivePenCamService()) {
            setIsAlivePenCamService(true, userSeq);
            let store = window.hiclasstv.store;
            const { user, live, hiclasstv } = store.getState();
            // const { userSeq, userNickname } = user;
            const { smartTVLiveInfo } = live;
            const { list_isConnectedOnScreenApp } = hiclasstv;

            /* const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
            if (connectedOnScreenApp_info) {
                xmitCmd_AndroidMessageForSmartTV("android", "ct_SmartTVResponse", enTokenCMD.ct_Response, userSeq, connectedOnScreenApp_info.userNickname, smartTVLiveInfo.liveSeq);
                if (clientInfo.funcProc) clientInfo.funcProc("connect");
            } */

            const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
            if (connectedOnScreenApp_info) {
                // xmitCmd_AndroidMessageForSmartTV("android", "ct_SmartTVResponse", enTokenCMD.ct_Response, userSeq, connectedOnScreenApp_info.userNickname, smartTVLiveInfo.liveSeq);
                xmitCmd_MessageForSmartTV("android", "ct_SmartTVResponse", enTokenCMD.ct_Response, userSeq, connectedOnScreenApp_info.userNickname, smartTVLiveInfo.liveSeq, false);
                let idx = connectedOnScreenApp_info.idx;
                if (idx > -1) {
                    if (clientInfo.funcProcArr) {
                        let funcProc = clientInfo.funcProcArr[idx].funcProc;
                        if (funcProc) {
                            funcProc("connect");
                        }
                    }
                } else {
                    if (clientInfo.funcProc) clientInfo.funcProc("connect");
                }
                // if (clientInfo.funcProc) clientInfo.funcProc("connect");
            }
        }
    } else {
        let myUserSeq = getMyUserSeq();
        if (userSeq === myUserSeq) {
            if (!getIsAlivePenCamService()) {
                setIsAlivePenCamService(true);
                let store = window.hiclasstv.store;
                const { user, live } = store.getState();
                const { userSeq, userNickname } = user;
                const { smartTVLiveInfo } = live;
                // xmitCmd_AndroidMessageForSmartTV("android", "ct_SmartTVResponse", enTokenCMD.ct_Response, userSeq, userNickname, smartTVLiveInfo.liveSeq);
                xmitCmd_MessageForSmartTV("android", "ct_SmartTVResponse", enTokenCMD.ct_Response, userSeq, userNickname, smartTVLiveInfo.liveSeq, false);
                const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
                if (connectedOnScreenApp_info) {
                    let idx = connectedOnScreenApp_info.idx;
                    if (idx > -1) {
                        if (clientInfo.funcProcArr) {
                            let funcProc = clientInfo.funcProcArr[idx].funcProc;
                            if (funcProc) {
                                funcProc("connect");
                            }
                        }
                    } else {
                        if (clientInfo.funcProc) clientInfo.funcProc("connect");
                    }
                } else {
                    if (clientInfo.funcProc) clientInfo.funcProc("connect");
                }
            }
        }
    }
}

const rcvCmd_AndroidSmartTVSharedModeStatus = (tokenCmd, userSeq, status) => {
    console.log(`rcvCmd_AndroidSmartTVSharedModeStatus - tokenCmd[${tokenCmd}], userSeq[${userSeq}], status[${status}]`);
    let myUserSeq = getMyUserSeq();
    if (userSeq === myUserSeq && tokenCmd === enTokenCMD.ct_UpdateHandsUpImage) {
        if (getIsAlivePenCamService()) {
            if (clientInfo.funcProc) clientInfo.funcProc(status);
        }
    }
}

const rcvCmd_AndroidSmartTVMode = (tokenCmd, mode) => {
    console.log(`rcvCmd_AndroidSmartTVMode - tokenCmd[${tokenCmd}], mode[${mode}]`);

    let funcProc;
    let idx = -1;

    if (getCurrentPageType() === enWebPage.GroupSmartTV) {
        const connectedOnScreenApp_info = getConnectedOnScreenAppInfoWithIndex(0);  // userSeq 가 없는 경우에는 0번 index 사용 ... by hjkim 20240105
        if (connectedOnScreenApp_info) {
            idx = connectedOnScreenApp_info.idx;
    
            if (idx > -1) {
                funcProc = clientInfo.funcProcArr[idx].funcProc;
            } else {
                funcProc = clientInfo.funcProc;
            }
        } else {
            funcProc = clientInfo.funcProc;
        }
    } else {
        funcProc = clientInfo.funcProc;
    }

    if (tokenCmd === enTokenCMD.ct_Poll) {
        if (funcProc) funcProc(mode, idx);
    }

    /* if (getIsAlivePenCamService()) {
        if (funcProc) funcProc(mode, idx);

        // if (tokenCmd === enTokenCMD.ct_Poll) {
        //     if (funcProc) funcProc(mode, idx);
        // }
    } else {
        if (funcProc) funcProc(mode);

        // if (tokenCmd === enTokenCMD.ct_Poll) {
        //     if (funcProc) funcProc(mode, idx);
        // }
    } */

    /* if (getCurrentPageType() === enWebPage.GroupSmartTV) {
        const connectedOnScreenApp_info = getConnectedOnScreenAppInfoWithIndex(0);  // userSeq 가 없는 경우에는 0번 index 사용 ... by hjkim 20240105 
    } else {
        if (tokenCmd === enTokenCMD.ct_Poll) {
            if (clientInfo.funcProc) clientInfo.funcProc(mode);
        }
    } */
}

const rcvCmd_AndroidSmartTVStatus = (tokenCmd, userSeq, status) => {
    console.log(`rcvCmd_AndroidSmartTVStatus - tokenCmd[${tokenCmd}], userSeq[${userSeq}], status[${status}]`);
    let myUserSeq = getMyUserSeq();
    console.log(`myUserSeq => [${myUserSeq}]`);
    if (userSeq === myUserSeq) {
        let funcProc;
        let idx = -1;

        if (getCurrentPageType() === enWebPage.GroupSmartTV) {
            const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
            console.log("getConnectedOnScreenAppInfo => ", connectedOnScreenApp_info);
            if (connectedOnScreenApp_info) {
                idx = connectedOnScreenApp_info.idx;

                if (idx > -1) {
                    funcProc = clientInfo.funcProcArr[idx].funcProc;
                } else {
                    funcProc = clientInfo.funcProc;
                }
            } else {
                funcProc = clientInfo.funcProc;
            }

            console.log("funcProc => ", funcProc);
        } else {
            funcProc = clientInfo.funcProc;
        }

        if (getIsAlivePenCamService()) {
            if (funcProc) funcProc(status, idx);

            // if (tokenCmd === enTokenCMD.ct_UpdateHandsUpImage) {
            //     if (funcProc) funcProc(status, idx);
            // } else if (tokenCmd === enTokenCMD.ct_Response) {
            //     if (funcProc) funcProc(status, idx);
            // } else if (tokenCmd === enTokenCMD.ct_Poll) {
            //     if (funcProc) funcProc(status, idx);
            // }
        } else {
            if (funcProc) funcProc(status);

            // if (tokenCmd === enTokenCMD.ct_Poll) {
            //     if (funcProc) funcProc(status, idx);
            // }
        }

        /* if (getIsAlivePenCamService()) {
            if (getCurrentPageType() === enWebPage.GroupSmartTV) {
                const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
                if (connectedOnScreenApp_info) {
                    let idx = connectedOnScreenApp_info.idx;
                    if (idx > -1) {
                        if (clientInfo.funcProcArr) {
                            let funcProc = clientInfo.funcProcArr[idx].funcProc;
                            if (funcProc) {
                                funcProc(status, idx);

                                // if (tokenCmd === enTokenCMD.ct_UpdateHandsUpImage) {
                                //     if (funcProc) funcProc(status);
                                // } else if (tokenCmd === enTokenCMD.ct_Response) {
                                //     if (funcProc) funcProc(status);
                                // } else if (tokenCmd === enTokenCMD.ct_Poll) {
                                //     if (funcProc) funcProc(status);
                                // }
                            }
                        }
                    }
                }
            } else {
                if (tokenCmd === enTokenCMD.ct_UpdateHandsUpImage) {
                    if (clientInfo.funcProc) clientInfo.funcProc(status);
                } else if (tokenCmd === enTokenCMD.ct_Response) {
                    if (clientInfo.funcProc) clientInfo.funcProc(status);
                } else if (tokenCmd === enTokenCMD.ct_Poll) {
                    if (clientInfo.funcProc) clientInfo.funcProc(status);
                }
            }
        } else {
            if (getCurrentPageType() === enWebPage.GroupSmartTV) {
                const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
                if (connectedOnScreenApp_info) {
                    let idx = connectedOnScreenApp_info.idx;
                    if (idx > -1) {
                        if (clientInfo.funcProcArr) {
                            let funcProc = clientInfo.funcProcArr[idx].funcProc;
                            if (funcProc) {
                                funcProc(status, idx);

                                // if (tokenCmd === enTokenCMD.ct_Poll) {
                                //     if (funcProc) funcProc(status);
                                // }
                            }
                        }
                    }
                }
            } else {
                if (tokenCmd === enTokenCMD.ct_Poll) {
                    if (clientInfo.funcProc) clientInfo.funcProc(status);
                }
            }
        } */
    }
}

const rcvUserStatus = (roomSeq, userSeq, status, routingKey) => {
    let store = window.hiclasstv.store;
    // console.log("userStatusRcv-status:" + status);
    // console.log(`rcvUserStatus ------ roomSeq[${roomSeq}], userSeq[${userSeq}], status[${status}], routingKey[${routingKey}]`);
    console.log(`rcvUserStatus ------ roomSeq[${roomSeq}], userSeq[${userSeq}], status[${status}], routingKey[`, routingKey, "]");

    switch (status) {
        case ConstCode.LOGIN:
            // 로그인 (in hiclass)
            store.dispatch(mqLoginFriend({ userSeq }));
            store.dispatch(mqLoginChat({ userSeq }));
            break;

        case ConstCode.LOGOUT: {
            // 로그아웃
            let myUserSeq = getMyUserSeq();
            let myRoutingKey = getMyRoutingKey();
            let isMe = userSeq === myUserSeq ? true : false;
            let isForceLogout = myRoutingKey === routingKey ? true : false;
            let mode = myRoutingKey.endsWith(".0") ? "web" : "hiclass";

            store.dispatch(mqLogoutFriend({ userSeq }));
            store.dispatch(mqLogoutChat({ userSeq, isMe }));

            if (isMe && isForceLogout) {
                store.dispatch(forceLogOutInit({ userSeq, mode, isSuccessed: true, isLogoutSuccess: true }));
                window.history.pushState({ data: "push" }, "", "/main");
            }
        } break;

        case ConstCode.LOGIN_WEB:
            // 로그인 (in web)
            console.log("web login rbmq");
            break;

        case ConstCode.LIVE_INFO_INIT: {
            // 선생님이 로그아웃 => Live Init 해야함 (handsup 모드 등)
            let myUserSeq = getMyUserSeq();
            store.dispatch(mqLiveInfoInit({ liveSeq: roomSeq, teacherSeq: userSeq, userSeq: myUserSeq }));

            // 260729 실제 교사 종료 흐름의 LIVE_INFO_INIT도 ClassMonitor 종료 알림으로 처리한다.
            if (getCurrentPageType() === enWebPage.ClassMonitor && clientInfo.classMonitorLiveOffProc) {
                clientInfo.classMonitorLiveOffProc(roomSeq);
            }

            if (getIsForPblModeBrowser()) {
                const { user, live } = store.getState();
                const params = new URLSearchParams(window.location.search);
                const userID = user.userID || params.get("userID") || "";
                const userNickname = user.userNickname || params.get("userNickname") || "";
                // 20260831 PBL 종료 후에도 믹스드클래스는 기존 mixed 로그인 화면으로 돌아가도록 분기한다.
                const isMixedPblLogin = live.isMixedClassMember && live.mixedClassInfo.mixedClassSeq > 0;
                const loginPath = isMixedPblLogin
                    ? `/pbl-mixed-login/${live.mixedClassInfo.mixedClassSeq}`
                    : `/pbl-login/${roomSeq}`;
                window.location = `${loginPath}?userID=${encodeURIComponent(userID)}&userNickname=${encodeURIComponent(userNickname)}`;
            }
        } break;

        case ConstCode.CANCEL_FRIEND_APPLY:
            // 친구 신청 취소 (hiclass -> web 또는 web -> hiclass 처리용)
            store.dispatch(mqCancelFriendMe({ userSeq }));
            break;

        case ConstCode.CANCELED_FRIEND_APPLY:
            // 친구 신청 취소됨
            store.dispatch(mqCancelFriend({ userSeq }));
            break;

        case ConstCode.REJECT_FRIEND_APPLY:
            // 친구 신청 거절 (hiclass -> web 또는 web -> hiclass 처리용)
            store.dispatch(mqRejectFriendMe({ userSeq }));
            break;

        case ConstCode.REJECTED_FRIEND_APPLY:
            // 친구 신청 거절
            store.dispatch(mqRejectFriend({ userSeq }));
            break;

        case ConstCode.REMOVE_FRIEND:
            // 친구 삭제
            store.dispatch(mqRemoveFriend({ userSeq }));
            break;

        case ConstCode.CHATROOM_JOIN:
            // 팀업 입장
            store.dispatch(mqUpdateFriendStatus({ userSeq, status: ConstData.USER_STATUS.STUDYING }));
            break;

        case ConstCode.CHATROOM_FINISH: {
            // 팀업 종료
            let myUserSeq = getMyUserSeq();
            let isMe = userSeq === myUserSeq ? true : false;
            store.dispatch(mqFinishChat({ roomSeq, userSeq, isMe }));
            store.dispatch(mqUpdateFriendStatus({ userSeq, status: ConstData.USER_STATUS.LOG_IN }));
        } break;

        case ConstCode.CHATROOM_EXIT:
            // 팀업 퇴장 (영구)
            store.dispatch(mqExitChat({ roomSeq, userSeq }));
            store.dispatch(mqUpdateFriendStatus({ userSeq, status: ConstData.USER_STATUS.LOG_IN }));
            break;

        case ConstCode.CHATROOM_REMOVE:
            // 팀업 삭제
            store.dispatch(mqRemoveChat({ roomSeq, userSeq }));
            break;

        case ConstCode.CHATROOM_MEMBER_REMOVE:
            // 팀업 멤버 삭제
            store.dispatch(mqRemoveChatMember({ roomSeq, userSeq }));
            break;

        case ConstCode.CHATROOM_MEMBER_REMOVED:
            // 팀업 멤버 퇴출
            store.dispatch(mqRemovedChatMember({ roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_ON:
            // 클래스 On
            store.dispatch(mqLiveOn({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_OFF:
            // 클래스 off
            store.dispatch(mqClearPage({ cmd: enTokenCMD.rq_PageClear }));
            store.dispatch(mqLiveOff({ liveSeq: roomSeq, userSeq }));
            // 260729 ClassMonitor는 별도 세션 상태를 사용하므로 종료 신호를 페이지 콜백에도 전달한다.
            if (getCurrentPageType() === enWebPage.ClassMonitor && clientInfo.classMonitorLiveOffProc) {
                clientInfo.classMonitorLiveOffProc(roomSeq);
            }
            break;

        case ConstCode.LIVE_REMOVE:
            // 클래스 삭제
            store.dispatch(mqRemoveLive({ liveSeq: roomSeq }));
            break;

        case ConstCode.LIVE_MEMBER_REJECT:
            // 클래스 멤버 거절
            store.dispatch(mqRejectLiveMember({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_MEMBER_REJECTED:
            // 클래스 멤버 거절됨
            store.dispatch(mqRejectedLiveMember({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_MEMBER_REMOVE:
            // 클래스 멤버 삭제
            store.dispatch(mqRemoveLiveMember({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_MEMBER_REMOVED:
            // 클래스 멤버 퇴출
            store.dispatch(mqRemovedLiveMember({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_JOIN:
            // 클래스 참여
            store.dispatch(mqJoinLive({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.LIVE_EXIT: {
            // 클래스 나가기
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    updateSmallGroupImage("disconnect", mixedClassInfo.serverLiveSeq, userSeq, null);
                } else {
                    console.log(`ct_UpdateHandsUpImage - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                updateSmallGroupImage("disconnect", roomSeq, userSeq, null);
            }
            store.dispatch(mqExitLive({ liveSeq: roomSeq, userSeq }));
        } break;

        case ConstCode.HANDS_UP_ON:
            // 학생이 hans up 함
            store.dispatch(mqHandsUpOn({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.HANDS_UP_OFF:
            // 학생이 hans up 취소 또는 선생님이 학생의  hans up을 끔
            store.dispatch(mqHandsUpOff({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.HANDS_UP_MODE_START:
            // hands up 시작
            store.dispatch(mqHandsUpStart({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.HANDS_UP_MODE_STOP:
            // hands up 종료
            store.dispatch(mqHandsUpStop({ liveSeq: roomSeq, userSeq }));
            break;

        case ConstCode.HANDS_UP_ACTIVE: {
            // hands up active
            let myUserSeq = getMyUserSeq();
            store.dispatch(mqHandsUpActive({ liveSeq: roomSeq, userSeq: myUserSeq }));
        } break;

        case ConstCode.HANDS_UP_INACTIVE: {
            // hands up inactive
            let myUserSeq = getMyUserSeq();
            store.dispatch(mqHandsUpInactive({ liveSeq: roomSeq, userSeq: myUserSeq }));
        } break;

        case ConstCode.MIC_ON: {
            // p2p sound on
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpMicOn(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`MIC_ON - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpMicOn(roomSeq, userSeq);
            }
        } break;

        case ConstCode.MIC_OFF: {
            // p2p sound off
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpMicOff(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`MIC_OFF - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpMicOff(roomSeq, userSeq);
            }
        } break;

        case ConstCode.DISABLE_MIC: {
            // p2p sound button disable
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpMicDisable(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`DISABLE_MIC - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpMicDisable(roomSeq, userSeq);
            }
        } break;

        case ConstCode.ENABLE_MIC: {
            // p2p sound button enable
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpMicEnable(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`ENABLE_MIC - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpMicEnable(roomSeq, userSeq);
            }
        } break;

        case ConstCode.START_P2P_AUDIO: {
            // p2p audio start
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    startHandsUpAudioConsume(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`START_P2P_AUDIO - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                startHandsUpAudioConsume(roomSeq, userSeq);
            }
        } break;

        case ConstCode.STOP_P2P_AUDIO: {
            // p2p audio stop
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    stopHandsUpAudioConsume(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`STOP_P2P_AUDIO - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                stopHandsUpAudioConsume(roomSeq, userSeq);
            }
        } break;

        case ConstCode.RESTART_P2P_MODE: {
            // p2p 재시작
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    restartHandsUpP2PMode(mixedClassInfo.serverLiveSeq, [userSeq]);
                } else {
                    console.log(`RESTART_P2P_MODE - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                restartHandsUpP2PMode(roomSeq, [userSeq]);
            }
        } break;

        /* case ConstCode.P2P_AUDIO_MUTE_MODE: {
            // sound mute mode
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpSoundMuteMode(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`P2P_AUDIO_MUTE_MODE - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpSoundMuteMode(roomSeq, userSeq);
            }
        } break;

        case ConstCode.P2P_AUDIO_LISTEN_MODE: {
            // sound listen mode
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === roomSeq) {
                    setHandsUpSoundListenMode(mixedClassInfo.serverLiveSeq, userSeq);
                } else {
                    console.log(`P2P_AUDIO_LISTEN_MODE - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${roomSeq}]`);
                }
            } else {
                setHandsUpSoundListenMode(roomSeq, userSeq);
            }
        } break; */

        case ConstCode.NOTIFY_START_MIXED_CLASS:
            store.dispatch(mqStartMixedClass({ liveSeq: roomSeq }));
            break;

        case ConstCode.NOTIFY_STOP_MIXED_CLASS:
            store.dispatch(mqStopMixedClass({ liveSeq: roomSeq }));
            break;

        case ConstCode.DISPLAY_ON:
            // display on
            store.dispatch(mqUpdateDisplayStatus({ studioSeq: roomSeq, displaySeq: userSeq, status: "Y" }));
            break;

        case ConstCode.DISPLAY_OFF:
            // display off
            store.dispatch(mqUpdateDisplayStatus({ studioSeq: roomSeq, displaySeq: userSeq, status: "N" }));
            break;

        default:
            console.log("status is default... -> ", status);
            break;
    }
}

/**
 * "content-send" (intensiveControl로 전달된 url/앱/파일/메시지) 중 'url-start' 처리 함수.
 * kind === "intensiveControl"/"whisper-intensiveControl"로 실시간 수신했을 때와,
 * kind === "pbl" / action === "groupChatList"로 받은 이력을 재생할 때 양쪽에서 재사용됨.
 *
 * @param {Object} information - { url, faviconUrl, contentSeq, refContentSeq, ... }
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {String} [kind="intensiveControl"] - ack 전송 시 사용할 kind(action) 값
 */
// 20260916 수신 URL 실행 경로를 말풍선 클릭에서도 재사용하며, 클릭 자체는 ACK를 발생시키지 않는다.
export const openContentSendUrlStart = (information, kind = "intensiveControl", openBrowserFallback = false) => {
    if (isAndroidWebView()) {
        window.callStartWebSiteLoadWithContentInfo({
            ...information,
            responseAction: kind,
        });
        return;
    }

    if (isWindowsWebView() && !getIsForPblModeBrowser()) {
        window.chrome.webview.postMessage({
            action: kind,
            kind: "url-start",
            ...information,
        });
        return;
    }

    if (isIOSWebView()) {
        xmitCmd_IosMessage("url-start", {
            ...information,
            responseAction: kind,
        });
        return;
    }

    // 20260916 기존 수신 처리에는 브라우저 폴백을 적용하지 않고, 말풍선 클릭에서만 일반 브라우저를 연다.
    if (openBrowserFallback && information && information.url) window.open(information.url, "_blank", "noopener,noreferrer");
};

const handleContentSendUrlStart = (information, routingKey, kind = "intensiveControl") => {
    const { url, contentSeq } = information;
    console.log("'url-start' 수신 완료. url => ", url);

    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname, userSeq } = user;

    // 20260916 URL 실행과 별개로 원본 정보를 보존한 말풍선을 남겨, 이후 클릭으로 다시 열 수 있게 한다.
    const selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    const profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
    store.dispatch(appendReceiveMessage({
        kind: "url_start",
        iconSeq: parseInt(profileImgUrl),
        rcvKind: selRcvKind,
        rcvName: information.userNickname || "선생님",
        text: url || "URL을 열어 주세요.",
        emoticSeq: -1,
        urlInfo: { ...information },
        urlStartInfo: { ...information },
    }));

    if (isAndroidWebView() || isWindowsWebView() || isIOSWebView()) {
        // 20260916 응답을 먼저 보낸 후 WebView에 전달하도록 수정
        sendJsonData({
            kind: "live",
            action: kind,
            information: {
                kind: "content-send-ack",
                contentType: "url-start",
                contentSeq,
                userSeq,
                status: "received",      // 정상 수신
            }
        }, userNickname);

        openContentSendUrlStart(information, kind);
    } else {
        // PC 웹 브라우저 등 미지원 기기
        console.log("url-start not supported ... ");

        sendJsonData({
            kind: "live",
            action: kind,
            information: {
                kind: "content-send-ack",
                contentType: "url-start",
                contentSeq,
                userSeq,
                status: "not_support",   // 미지원 기기
            }
        }, userNickname);
    }
}

/**
 * "content-send" 중 'app-start' 처리 함수. handleContentSendUrlStart와 동일한 이유로 공용화됨.
 *
 * @param {Object} information - { appSeq, appName, appPkgData, faviconUrl, contentSeq, refContentSeq, ... }
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {String} [kind="intensiveControl"] - ack 전송 시 사용할 kind(action) 값
 */
const handleContentSendAppStart = (information, routingKey, kind = "intensiveControl") => {
    const { appSeq, appName, appPkgData, faviconUrl, contentSeq } = information;
    console.log("'app-start' 수신 완료. app => ", appSeq, appName, appPkgData, faviconUrl);
    console.log("appPkgData => ", appPkgData, "typeof appPkgData => ", typeof appPkgData);

    try {
        information.appPkgData = typeof appPkgData === "string"
            ? JSON.parse(appPkgData)
            : appPkgData;
    } catch (error) {
        console.log("handleContentSendAppStart err => ", error);
        information.appPkgData = null;
    }

    console.log(information);

    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname, userSeq } = user;

    if (isAndroidWebView() || isWindowsWebView() || isIOSWebView()) {
        // 20260916 응답을 먼저 보낸 후 WebView에 전달하도록 수정
        sendJsonData({
            kind: "live",
            action: kind,
            information: {
                kind: "content-send-ack",
                contentType: "app-start",
                contentSeq,
                userSeq,
                status: "received",      // 정상 수신
            }
        }, userNickname);

        if (isAndroidWebView()) {
            window.callStartApp({
                ...information,
                responseAction: kind,
            });
        } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
            window.chrome.webview.postMessage({
                action: kind,
                kind: "app-start",
                ...information,
            });
        } else if (isIOSWebView()) {
            // 여기에 ios 하시오. (전달된 url로 웹뷰 띄우기)
            console.log("app-start 수신 완료. ios 웹뷰에 전달해야 함.");
            xmitCmd_IosMessage("app-start", {
                ...information,
                responseAction: kind,
            });
        }
    } else {
        console.log("app-start not supported ... ");

        sendJsonData({
            kind: "live",
            action: kind,
            information: {
                kind: "content-send-ack",
                contentType: "app-start",
                contentSeq,
                userSeq,
                status: "not_support",   // 미지원 기기
            }
        }, userNickname);
    }
}

/**
 * "content-send" 중 'file-upload' 처리 함수. handleContentSendUrlStart와 동일한 이유로 공용화됨.
 * information에 userNickname이 없는 호출(예: groupChatList 이력)을 위해 fallbackUserNickname을 지원함.
 *
 * @param {Object} information - { originalFileName, uploadedPath, fileTransferType, isAutoDownloadAllowed, isOverwriteAllowed, executeYn, contentSeq, refContentSeq, ... }
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {String} [kind="intensiveControl"] - ack 전송 및 rcvChatFile ack에 사용할 kind(action) 값
 * @param {String} [fallbackUserNickname=""] - information.userNickname이 없을 때 사용할 발신자 닉네임
 * @param {Boolean} [forceWhisper=false] - true면 routingKey와 무관하게 귓속말 말풍선으로 표시(groupChatList 이력 재생용)
 */
const handleContentSendFileUpload = (information, routingKey, kind = "intensiveControl", fallbackUserNickname = "", forceWhisper = false) => {
    const { originalFileName, uploadedPath, fileTransferType = "file-transfer", isAutoDownloadAllowed, isOverwriteAllowed, executeYn, userNickname: infoUserNickname, contentSeq, contentTeacherSeq, refContentSeq, mixedClassTransferId } = information;
    const userNickname = infoUserNickname || fallbackUserNickname;
    console.log(information);

    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userSeq } = user;

    if (isWindowsWebView() && !getIsForPblModeBrowser()) {
        window.chrome.webview.postMessage({
            action: kind,
            kind: "file-upload",
            ...information,
        });
    }

    const finalIsAutoDownloadAllowed = executeYn === "Y" ? true : isAutoDownloadAllowed;
    rcvChatFile(uploadedPath, userNickname, routingKey, originalFileName, fileTransferType, finalIsAutoDownloadAllowed, isOverwriteAllowed, executeYn, { contentSeq, contentTeacherSeq, refContentSeq, userSeq }, kind, forceWhisper, mixedClassTransferId);
}

const showMixedCloudFilePreparing = (information, userNickname, routingKey) => {
    const { mixedClassTransferId, originalFileName } = information || {};
    if (!mixedClassTransferId) return;

    const store = window.hiclasstv.store;
    const selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    const profileImgUrl = getProfileImgUrl(selRcvKind, routingKey);
    // 20260901 추가: 신형 믹스드 직접 저장의 클라우드 수신자에게만 다운로드 전 준비 상태를 보여준다.
    store.dispatch(appendReceiveMessage({
        kind: "file_share",
        iconSeq: parseInt(profileImgUrl),
        rcvKind: selRcvKind,
        rcvName: userNickname,
        text: `${userNickname}님이 ${originalFileName || "파일"}을 준비하고 있습니다.`,
        originalFileName,
        isMixedFilePreparing: true,
        mixedClassTransferId,
        isDownloadButtonVisible: true
    }));
}

/**
 * "content-send" 중 'message' 처리 함수. handleContentSendUrlStart와 동일한 이유로 공용화됨.
 * information에 userNickname이 없는 호출(예: groupChatList 이력)을 위해 fallbackUserNickname을 지원함.
 *
 * @param {Object} information - { message, contentSeq, refContentSeq, ... }
 * @param {String} routingKey - 전달받은 메시지 라우팅 키
 * @param {String} [kind="intensiveControl"] - ack 전송 시 사용할 kind(action) 값
 * @param {String} [fallbackUserNickname=""] - information.userNickname이 없을 때 사용할 발신자 닉네임
 * @param {Boolean} [forceWhisper=false] - true면 routingKey와 무관하게 귓속말 말풍선으로 표시(groupChatList 이력 재생용)
 */
const handleContentSendMessage = (information, routingKey, kind = "intensiveControl", fallbackUserNickname = "", forceWhisper = false) => {
    const { message, userNickname: infoUserNickname, contentSeq, refContentSeq } = information;
    const userNickname = infoUserNickname || fallbackUserNickname;
    console.log("'message' 수신 완료 - ", information);

    // 전달받은 메시지가 비어있으면 처리하지 않음
    if (!isNotEmptyStr(message)) {
        console.log("handleContentSendMessage - 전달받은 메시지가 비어있음");
        return;
    }

    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userSeq } = user;

    // ── 기존 rcvChatText 재사용 ────────────────────────────────────
    rcvChatText(userNickname, 0, -1, message, routingKey, { contentSeq, refContentSeq, userSeq }, kind, forceWhisper);
}

/**
 * RestApi or HandsUp 창 or Frontend 에서 온 데이터 처리
 * @param {Object} dataObject       JsonObject로 kind, action, information으로 구성됨
 * @param {String} userNickname     message를 보낸 이의 userNickname
 * @param {String} routingKey       message를 수신한 bindKey
 */
const rcvJsonData = (dataObject, userNickname, routingKey) => {
    const { kind, action, information } = dataObject;
    let store = window.hiclasstv.store;
    // console.log(`rcvJsonData() - userNickname[${userNickname}], routingKey[${routingKey}], dataObject => `, dataObject);
    console.log("rcvJsonData() - userNickname[", userNickname, "], routingKey[", routingKey, "], dataObject => ", dataObject);

    if (kind === "user") {
        if (action === "logout") {
            const { userSeq } = information;
            store.dispatch(mqLogoutFriend({ userSeq }));
            store.dispatch(mqLogoutChat({ userSeq, isMe: userSeq === getMyUserSeq() }));
        } else if (action === "force-logout") {
            const { userSeq } = information;
            if (userSeq === getMyUserSeq()) {
                store.dispatch(forceLogOutInit(information));
                window.history.pushState({ data: "push" }, "", "/main");
            }
        } else if (action === "create") {
            const { update_info } = information;
            // friend, chatting, live에 모두 처리하기
            store.dispatch(mqUpdateFriendInfo({ update_info }));
            store.dispatch(mqUpdateChatMemberInfo({ update_info }));
            store.dispatch(mqUpdateLiveMemberInfo({ update_info }));
        } else if (action === "update") {
            const { update_info } = information;
            // friend, chatting, live에 모두 처리하기
            store.dispatch(mqUpdateInfo({ update_info }));
            store.dispatch(mqUpdateFriendInfo({ update_info }));
            store.dispatch(mqUpdateChatMemberInfo({ update_info }));
            store.dispatch(mqUpdateLiveMemberInfo({ update_info }));
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "chatting") {
        if (action === "create") {
            const { chatRoom_info } = information;
            store.dispatch(mqCreateChat({ chatRoom_info }));
        } else if (action === "update") {
            const { chatRoom_info } = information;
            store.dispatch(mqUpdateChat({ chatRoom_info }));
        } else if (action === "update-name") {
            const { chatRoom_info } = information;
            store.dispatch(mqNameUpdateChat({ chatRoom_info }));
        } else if (action === "update-mode") {
            const { chatRoom_info } = information;
            store.dispatch(mqModeUpdateChat({ chatRoom_info }));
        } else if (action === "update-type") {
            const { chatRoom_info } = information;
            store.dispatch(mqTypeUpdateChat({ chatRoom_info }));
        } else if (action === "join") {
            const { join_info } = information;
            const { chatRoomSeq, userSeq } = join_info;
            let myUserSeq = getMyUserSeq();
            let isMe = userSeq === myUserSeq ? true : false;
            store.dispatch(mqJoinChat({ join_info, isMe }));
            // store.dispatch({ type : SAGA_JOIN, payload : { join_info }});
        } else if (action === "invite") {
            const { chatRoom_info } = information;
            store.dispatch(mqInviteChatMember({ chatRoom_info }));
        } else if (action === "add-member") {
            const { add_info } = information;
            store.dispatch(mqAddChatMember({ add_info }));
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "friend") {
        if (action === "add") {
            const { user_info } = information;
            store.dispatch(mqAddFriend({ user_info }));
        } else if (action === "rcv-apply") {
            const { user_info } = information;
            store.dispatch(mqApplyFriend({ user_info }));
        } else if (action === "send-apply") {
            const { user_info } = information;
            store.dispatch(mqSendApplyFriend({ user_info }));
        } else if (action === "multiple-apply") {
            const { list_user } = information;
            store.dispatch(mqMultipleApplyFriend({ list_user }));
        } else if (action === "multiple-add") {
            const { list_user } = information;
            store.dispatch(mqMultipleAddFriend({ list_user }));
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "live") {
        if (action === "live-on") {
            const { liveSeq, userSeq, isLiveChattingLocked, isTouchScreenLocked } = information;
            // 클래스 On
            console.log(`kind[${kind}] action[${action}] liveSeq[${liveSeq}] userSeq[${userSeq}] isLiveChattingLocked[${isLiveChattingLocked}] isTouchScreenLocked[${isTouchScreenLocked}]`);
            store.dispatch(mqLiveOn({ liveSeq, userSeq, isLiveChattingLocked, isTouchScreenLocked }));
        } else if (action === "create") {
            const { live_info } = information;
            store.dispatch(mqCreateLive({ live_info }));
        } else if (action === "edit-name") {
            const { edit_info } = information;
            store.dispatch(mqEditLiveName({ edit_info }));
        } else if (action === "update-broadcastDate") {
            const { edit_info } = information;
            store.dispatch(mqUpdateBroadcastDate({ edit_info }));
        } else if (action === "apply-live") {
            const { apply_info } = information;
            store.dispatch(mqApplyLive({ apply_info }));
        } else if (action === "approve-member") {
            const { member_info } = information;
            store.dispatch(mqApproveLiveMember({ member_info }));
        } else if (action === "add-member") {
            const { member_info } = information;
            store.dispatch(mqAddLiveMember({ member_info }));
        } else if (action === "approve-live") {
            const { live_info } = information;
            // console.log("approve-live... ", live_info);
            store.dispatch(mqApproveLive({ live_info }));
        } else if (action === "broadcast-open") {
            const { liveSeq } = information;
            store.dispatch(mqBroadcastOn({ liveSeq }));
        } else if (action === "broadcast-close") {
            const { liveSeq } = information;
            store.dispatch(mqBroadcastOff({ liveSeq }));
        } else if (action === "chatting-lock") {
            const { liveSeq, userSeq, isLiveChattingLocked } = information;
            store.dispatch(mqChattingLock({ liveSeq, userSeq, isLiveChattingLocked }));
            store.dispatch(closeWhisperModal());
        } else if (action === "update-nickname") {
            const { user_info } = information;
            console.log(`kind[${kind}] action[${action}] information => `, information);
            store.dispatch(mqUpdateLiveMemberNickname({ user_info }));
            // 260728 ClassMonitor는 Redux 라이브 목록과 별도 세션 상태를 사용하므로 콜백으로 닉네임만 갱신한다.
            if (getCurrentPageType() === enWebPage.ClassMonitor && clientInfo.classMonitorNicknameProc) {
                clientInfo.classMonitorNicknameProc(user_info);
            }
        } else if (action === "intensiveControl" || action === "whisper-intensiveControl") {
            const infoKind = information.kind;
            console.log(`kind[${kind}] action[${action}] infoKind[${infoKind}] information => `, information);
            if (infoKind && infoKind === "content-send-ack") {
                store.dispatch(updateContentSendStatus(information));
            }
        } else if (action === "logout") {
            const { liveSeq, teacherSeq } = information;
            const { live } = store.getState();
            const { performLiveInfo } = live;
            if (performLiveInfo.liveSeq === liveSeq) {
                console.log("performLiveInfo.liveSeq === liveSeq");
                const { user } = store.getState();
                const { userSeq } = user;
                console.log("call mqLogoutFriend(userSeq)", userSeq);
                store.dispatch(mqLogoutFriend({ userSeq }));
                console.log("call mqLogoutChat(userSeq)", userSeq);
                store.dispatch(mqLogoutChat({ userSeq, isMe: userSeq === getMyUserSeq() }));

                //if (isMe && isForceLogout) {
                    store.dispatch(forceLogOutInit({ userSeq, mode: "web", isSuccessed: true, isLogoutSuccess: true }));
                    window.history.pushState({ data: "push" }, "", "/main");
                //}
            } else {
                console.log("performLiveInfo.liveSeq is => ", performLiveInfo.liveSeq);
            }
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "handsup") {
        if (action === "screenStateChanged" && clientInfo.classMonitorScreenStateProc) {
            // 260803 ClassMonitor 회신을 학생의 최대화/최소화 버튼 글자와 다음 요청 상태에 반영한다.
            clientInfo.classMonitorScreenStateProc(information);
        } else if (action === "initPAD") {
            const { kind } = information;
            console.log("initPAD - ", kind);
            if (kind === "video_on") {
                if (clientInfo.funcProc) clientInfo.funcProc("initPAD", true);
            } else {
                if (clientInfo.funcProc) clientInfo.funcProc("initPAD", false);
            }
        } else if (action === "audioSourceSettings") {
            // 20261001 일반 Pro는 PBL_Action 없이 기존 handsup JSON 요청·응답 규약으로 처리한다.
            processHandsUpAudioSourceSettings(information);
        } else if (action === "p2pstart") {
            const { topKind, liveSeq, list_user } = information;
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    handleHandsUpP2PMode_new(topKind, mixedClassInfo.serverLiveSeq, list_user);
                } else {
                    console.log(`kind[${kind}] action[${action}] mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                handleHandsUpP2PMode_new(topKind, liveSeq, list_user);
            }
        } else if (action === "audioSelect") {
            const { liveSeq, list_user } = information;
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    initHandsUpAudioConsume(mixedClassInfo.serverLiveSeq, list_user);
                } else {
                    console.log(`kind[${kind}] action[${action}] mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                initHandsUpAudioConsume(liveSeq, list_user);
            }
        } else if (action === "pblStudentAudioListen") {
            // 20260928 오디오 관련 설정 변경: 현재 PBL 클래스의 그룹 오디오만 로컬에서 음소거한다.
            const { liveSeq, isEnabled } = information || {};
            const { live } = store.getState();
            const { isMixedClassMember, mixedClassInfo, performLiveInfo } = live;
            if (typeof isEnabled === "boolean") {
                if (isMixedClassMember && mixedClassInfo && mixedClassInfo.localLiveSeq === liveSeq) {
                    setPblStudentAudioListen(mixedClassInfo.serverLiveSeq, isEnabled);
                } else if (!isMixedClassMember && performLiveInfo && performLiveInfo.liveSeq === liveSeq) {
                    setPblStudentAudioListen(liveSeq, isEnabled);
                }
            }
        } else if (action === "smallGroupStart") {
            const { bindKey, sendKey, list_user, liveSeq } = information;
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo, performLiveInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    if (performLiveInfo.liveSeq === mixedClassInfo.serverLiveSeq) {
                        let newBindKeyArr = getReplacedRoutingKeyForMixedClass(bindKey, mixedClassInfo.localLiveSeq, mixedClassInfo.serverLiveSeq);
                        let newSendKey = getReplacedRoutingKeyForMixedClass(sendKey, mixedClassInfo.localLiveSeq, mixedClassInfo.serverLiveSeq);
                        subscribeSmallGroup(newSendKey, newBindKeyArr);
                        handleGroupStudyMode(true, list_user, getMySmallGroupImageSendKey());
                        store.dispatch(mqSmallGroupStart({ list_user }));
                    } else {
                        console.log(`kind[${kind}] action[${action}] mixedClassInfo.serverLiveSeq[${mixedClassInfo.localLiveSeq}], performLiveInfo.liveSeq[${performLiveInfo.liveSeq}]`);
                    }
                } else {
                    console.log(`kind[${kind}] action[${action}] mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                const { performLiveInfo } = live;
                if (performLiveInfo.liveSeq === liveSeq) {
                    subscribeSmallGroup(sendKey, bindKey);
                    handleGroupStudyMode(true, list_user, getMySmallGroupImageSendKey());
                    store.dispatch(mqSmallGroupStart({ list_user }));
                }
            }
        } else if (action === "smallGroupEnd") {
            console.log(`kind[${kind}] action[${action}] information => `, information);
            unsubscribeSmallGroup();
            handleGroupStudyMode(false, []);
            store.dispatch(mqSmallGroupStop());
        } else if (action === "netImageFrames") {
            console.log(`kind[${kind}] action[${action}] information => `, information);
            const { liveSeq, configFPS } = information;
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    setConfigFPS(mixedClassInfo.serverLiveSeq, configFPS);
                } else {
                    console.log(`kind[${kind}] action[${action}] mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                setConfigFPS(liveSeq, configFPS);
            }
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "mixedClass") {
        if (action === "loginInfo") {
            information.mode = "web";
            store.dispatch(mixedClassLoginSuccess(information));
        } else if (action === "liveMemberList") {
            store.dispatch(updateMixedClassMemberList(information));
        } else if (action === "liveJoin") {
            store.dispatch(joinMixedClassLive({
                userSeq: getMyUserSeq(),
                ...information
            }));
        } else if (action === "liveFinish") {
            store.dispatch(finishMixedClassLive(information));
        } else if (action === "logout") {
            store.dispatch(mixedClassLogoutSuccess(information));
        }
    } else if (kind === "classTalk") {
        if (action === "chat_FileTransferPreparing") {
            showMixedCloudFilePreparing(information, userNickname, routingKey);
        } else if (action === "chat_FileTransfer") {
            const { originalFileName, uploadedPath, fileTransferType = "file-transfer", isAutoDownloadAllowed, isOverwriteAllowed, executeYn, mixedClassTransferId } = information;
            console.log("information => ", information);
            const finalIsAutoDownloadAllowed = executeYn === "Y" ? true : isAutoDownloadAllowed;
            rcvChatFile(uploadedPath, userNickname, routingKey, originalFileName, fileTransferType, finalIsAutoDownloadAllowed, isOverwriteAllowed, executeYn, null, "intensiveControl", undefined, mixedClassTransferId);
        } else {
            console.log("action is else... ", action);
        }
    } else if (kind === "studio") {
        if (action === "assign-user") {
            const { studioSeq, userSeq, list_display } = information;
            store.dispatch(mqUpdateStudioUser({ studioSeq, userSeq, list_display }));
        } else if (action === "clear-user") {
            const { studioSeq } = information;
            store.dispatch(mqUpdateStudioUser({ studioSeq, userSeq: -1 }));
        } else if (action === "assign-live") {
            const { studioSeq, userSeq, liveSeq } = information;
            store.dispatch(mqUpdateStudioLive({ studioSeq, userSeq, liveSeq }));
        } else if (action === "clear-live") {
            const { studioSeq, userSeq } = information;
            store.dispatch(mqUpdateStudioLive({ studioSeq, userSeq, liveSeq: -1 }));
        }
    } else if (kind === "display") {
        if (action === "changed-info") {
            const { displaySeq, prevInfo, assingedInfo } = information;
        }
    } else if (kind === "android") {
        if (action === "ct_Login") {
            const { userSeq } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}]`);
            rcvCmd_AndroidLogin(userSeq);
        } else if (action === "ct_LoginResp") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            /* if (status === enTabStatus.Connected) {
                rcvCmd_AndroidLoginResp(userSeq);
            } else {
                console.log(`already connected pencam service`);
            } */
            rcvCmd_AndroidLoginResp(userSeq);
        } else if (action === "ct_Logout") {
            const { userSeq } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}]`);
            rcvCmd_AndroidLogout(userSeq);
        } else if (action === "ct_LogoutResp") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidLogoutResp(userSeq);
        } else if (action === "ct_ReconnModeResp") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidReconnResp(userSeq);
        } else if (action === "ct_StartScreenCapture" || action === "ct_StopScreenCapture") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidCaptureStatus(action, userSeq, status);
        } else if (action === "ct_MicOn") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidMicStatus(userSeq, status);
        } else if (action === "ct_MicOff") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidMicStatus(userSeq, status);
        } else if (action === "ct_TouchScreenLock" || action === "ct_TouchScreenUnLock") {
            const { liveSeq, userSeq, isTouchScreenLocked } = information;
            console.log(`kind[${kind}] action[${action}] liveSeq[${liveSeq}] userSeq[${userSeq}] isTouchScreenLocked[${isTouchScreenLocked}]`);
            store.dispatch(mqTouchScreenLock({ liveSeq, userSeq, isTouchScreenLocked }));
            rcvCmd_TouchScreen(liveSeq, userSeq, isTouchScreenLocked);
        } else if (action === "ct_SmartTVResponse") {
            const { userSeq, status } = information;
            console.log(`kind[${kind}] action[${action}] userSeq[${userSeq}] status[${status}]`);
            rcvCmd_AndroidSmartTVResponse(userSeq);
        }
    } else if (kind === "smart_tv") {
        // console.log(`kind[${kind}], action[${action}] => `, information);
        console.log("kind[", kind, "], action[", action, "] => ", information);
        if (action === "bindInfo") {
            const { isCanBind, bindKeyArr, userIndexArr, groupUserIndexArr, startSeqOfSmartTV, serverGateWay } = information;
            const { hiclasstv } = store.getState();
            const { list_qrLoginMember } = hiclasstv;
            if (isCanBind) {
                // const { bindKeyArr, startSeqOfSmartTV, serverGateWay } = information;
                // connectLiveForSmartTV(bindKeyArr, startSeqOfSmartTV, serverGateWay);
                /* if (information.list_member) {
                    store.dispatch(mqRcvSmartTVBindInfo({ bindKeyArr, startSeqOfSmartTV, serverGateWay, list_member: information.list_member }));
                } else {
                    store.dispatch(mqRcvSmartTVBindInfo({ bindKeyArr, startSeqOfSmartTV, serverGateWay }));
                } */
                // store.dispatch(mqRcvSmartTVBindInfo(information));
                if (userIndexArr) {
                    // 260728 ClassMonitor는 QR 로그인 목록 대신 세션의 전체 학생 목록을 사용한다.
                    const sourceMembers = getCurrentPageType() === enWebPage.ClassMonitor ? getSmartTVListMember() : list_qrLoginMember;
                    const list_member = userIndexArr.map(idx => sourceMembers[idx]).filter(Boolean);
                    // 260728 ClassMonitor 그룹 보기는 client_new가 계산한 전체 그룹 인덱스를 함께 보관한다.
                    store.dispatch(mqRcvSmartTVBindInfo({ bindKeyArr, startSeqOfSmartTV, serverGateWay, list_member, groupUserIndexArr }));
                    store.dispatch(setSmartTVGroupListMember({ list_member }));
                } else {
                    console.log("스마트TV 연결 정보 요청 후 잘못된 데이터를 받음!!!!");
                }
            } else {
                console.log(`kind[${kind}], action[${action}], isCanBind[${isCanBind}], information => `, information);
                alert("선생님이 해당 수업을 선택하지 않았습니다. 선생님께 문의하세요.");
                // window.history.back();
                window.location.reload();
            }
        } else if (action === "ct_SwitchTeacherFullMode") {
            const { tokenCmd } = information;
            // console.log(`kind[${kind}] action[${action}] tokenCmd[${tokenCmd}]`);
            console.log(`ct_SwitchTeacherFullMode - tokenCmd[${tokenCmd}]`);
            console.log(information);
            rcvCmd_AndroidSmartTVMode(tokenCmd, "media_full_mode");
        } else if (action === "ct_SwitchStudentFullMode") {
            const { tokenCmd } = information;
            // console.log(`kind[${kind}] action[${action}] tokenCmd[${tokenCmd}]`);
            console.log(`ct_SwitchStudentFullMode - tokenCmd[${tokenCmd}]`);
            console.log(information);
            rcvCmd_AndroidSmartTVMode(tokenCmd, "image_full_mode");
        } else if (action === "ct_SwitchStudentVideoResolution") {
            const { tokenCmd, userSeq, liveSeq, mode, localStreamingMode, smartTVTempKey } = information;
            // let isSmartTVMode = mode === "image_full_mode" ? true : false;
            // console.log(`ct_SwitchStudentVideoResolution - userSeq[${userSeq}], liveSeq[${liveSeq}], tokenCmd[${tokenCmd}], mode[${mode}], isSmartTVMode[${isSmartTVMode}]`);
            console.log(`ct_SwitchStudentVideoResolution - userSeq[${userSeq}], liveSeq[${liveSeq}], tokenCmd[${tokenCmd}], mode[${mode}], localStreamingMode[${localStreamingMode}], smartTVTempKey[${smartTVTempKey}]`);
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    handleHandsUpSmartTVMode(mixedClassInfo.serverLiveSeq, userSeq, mode, localStreamingMode, smartTVTempKey);
                } else {
                    console.log(`ct_SwitchStudentVideoResolution - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                handleHandsUpSmartTVMode(liveSeq, userSeq, mode, localStreamingMode, smartTVTempKey);
            }
        } else if (action === "ct_StartScreenCapture") {
            const { tokenCmd, userSeq } = information;
            console.log(`ct_StartScreenCapture - userSeq[${userSeq}], tokenCmd[${tokenCmd}]`);
            rcvCmd_AndroidSmartTVStatus(tokenCmd, userSeq, "shared-screen-mode");
        } else if (action === "ct_StopScreenCapture") {
            const { tokenCmd, userSeq } = information;
            console.log(`ct_StopScreenCapture - userSeq[${userSeq}], tokenCmd[${tokenCmd}]`);
            rcvCmd_AndroidSmartTVStatus(tokenCmd, userSeq, "shared-camera-mode");
        } else if (action === "ct_StopHandsUp" || action === "ct_LiveOff") {
            const { tokenCmd, userSeq } = information;
            console.log(`${action} - userSeq[${userSeq}], tokenCmd[${tokenCmd}]`);
            rcvCmd_AndroidSmartTVStatus(tokenCmd, userSeq, "shared-stop-mode");
        } else if (action === "ct_SmartTVLogout") {
            const { tokenCmd, userSeq, liveSeq, mode, smartTVTempKey } = information;
            // let isSmartTVMode = mode === "image_full_mode" ? true : false;
            // console.log(`ct_SmartTVLogout - userSeq[${userSeq}], liveSeq[${liveSeq}], tokenCmd[${tokenCmd}], mode[${mode}], isSmartTVMode[${isSmartTVMode}]`);
            console.log(`ct_SmartTVLogout - userSeq[${userSeq}], liveSeq[${liveSeq}], tokenCmd[${tokenCmd}], mode[${mode}], smartTVTempKey[${smartTVTempKey}]`);
            const { live } = store.getState();
            const { isMixedClassMember } = live;
            if (isMixedClassMember) {
                const { mixedClassInfo } = live;
                if (mixedClassInfo.localLiveSeq === liveSeq) {
                    // 260804 로그아웃 키가 localStreamingMode 인자로 밀리지 않도록 Thumbnail 모드를 명시한다.
                    handleHandsUpSmartTVMode(mixedClassInfo.serverLiveSeq, userSeq, false, enP2PMode.Thumbnail, smartTVTempKey);
                } else {
                    console.log(`ct_SmartTVLogout - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                }
            } else {
                // 260804 로그아웃 키가 localStreamingMode 인자로 밀리지 않도록 Thumbnail 모드를 명시한다.
                handleHandsUpSmartTVMode(liveSeq, userSeq, false, enP2PMode.Thumbnail, smartTVTempKey);
            }
        } else if (action === "userScreenMax") {
            const {userIndex} = information;
            if (getCurrentPageType() === enWebPage.GroupSmartTV) {
                clientInfo.smartTVUserScreenMaxProc({ kind: "image_full_mode",idx:userIndex, userSeq:-1});
            }
        } else if (action === "ct_GroupRest") {
            console.log(`kind[${kind}], action[${action}], information => `, information);
            if (getCurrentPageType() === enWebPage.ClassMonitor && clientInfo.classMonitorGroupResetProc) {
                // 260728 ClassMonitor는 연결을 유지한 채 최신 그룹 정보를 다시 조회한다.
                clientInfo.classMonitorGroupResetProc(information);
            } else {
                alert("선생님이 그룹설정을 재정의 하였습니다. 스마트 TV를 재시작합니다.");
                window.location.reload();
            }
        }
    } else if (kind === "quiz") {
        if (action === "sendQuizInfo") {
            const { live } = store.getState();
            const { performLiveInfo } = live;
            let profileImgUrl = "0";

            if (performLiveInfo.teacher_info !== undefined && performLiveInfo.teacher_info !== null) {
                profileImgUrl = performLiveInfo.teacher_info.profileImgUrl;

                const { quizSeq, data, msgIndex } = information;
                store.dispatch(mqRcvQuiz({ userNickname, data, quizSeq, msgIndex, iconSeq: parseInt(profileImgUrl) }));
            }
        } else if (action === "quizResponseFinish") {
            /* const { live } = store.getState();
            const { performLiveInfo} = live; */

            const { liveSeq, idx, quizSeq, list_member } = information;
            store.dispatch(mqRcvResponseFinishQuiz({ liveSeq, idx, quizSeq, list_member }));
        }
    } else if (kind === "pbl") {
        console.log("rcv json data -- ", kind, action, information);
        if (action === "groupChatList") {
            const { list_groupChat } = information;

            // 선생님이 미리 보내둔 콘텐츠 전송(content-send) 메시지들을 이력으로 받은 경우,
            // 실시간 intensiveControl 수신 때와 동일한 처리 루틴(url-start/app-start/file-upload/message)을
            // 그대로 재실행한다 ... by ri 20260710
            //
            // 주의 1) content-send 원본 항목(msgInfo.rcvKind === ContentSend)은 SendMessage.js/ReceiveMessage.js에서
            // 자체적으로 완성된 말풍선을 그려주는데, handleContentSendMessage/handleContentSendFileUpload는
            // 내부적으로 rcv(귓속말) 말풍선을 추가로 만든다.
            // 원본 항목을 그대로 dispatch에 남겨두면 말풍선이 2번(원본 ContentSend 말풍선 + 새로 만든 말풍선)
            // 보이므로, content-send 항목은 원본 그대로 dispatch하지 않는다.
            // (url-start/app-start는 말풍선 없이 사이드 이펙트만 재실행하고 끝냄)
            //
            // 주의 2) content-send 항목은 위 함수들이 그 자리에서 즉시 dispatch(appendReceiveMessage)하고,
            // 일반 항목은 mqRcvGroupChatList로 dispatch한다. list_groupChat 전체를 모았다가 나중에
            // 한 번에 dispatch하면, "content-send 항목만 먼저 다 붙고 일반 항목이 뒤에 붙는" 식으로
            // 원래 순서(a-b-c)가 깨진다(a-c-b처럼). 그래서 원본 순서를 지키기 위해 항목 하나마다
            // 바로바로(forEach 루프 안에서) dispatch한다.
            if (Array.isArray(list_groupChat) && list_groupChat.length > 0) {
                list_groupChat.forEach((chatItem) => {
                    const msgInfo = chatItem && chatItem.msgInfo;
                    if (!msgInfo || msgInfo.rcvKind !== ctRcvKind.ContentSend) {
                        store.dispatch(mqRcvGroupChatList({ list_groupChat: [chatItem] }));
                        return;
                    }

                    const contentInformation = msgInfo.information;
                    if (!contentInformation) {
                        store.dispatch(mqRcvGroupChatList({ list_groupChat: [chatItem] }));
                        return;
                    }

                    // 미리 보내둔 content-send 이력은 학생 쪽에 귓속말(whisper)로 표시 ... by ri 20260710
                    switch (contentInformation.contentType) {
                        case "url-start":
                            // 말풍선 없이 웹뷰 URL 오픈 + ack만 재실행 ... by ri 20260710
                            handleContentSendUrlStart(contentInformation, routingKey);
                            break;

                        case "app-start":
                            // 말풍선 없이 앱 실행 + ack만 재실행 ... by ri 20260710
                            handleContentSendAppStart(contentInformation, routingKey);
                            break;

                        case "file-upload":
                            // rcvChatFile이 forceWhisper=true로 귓속말 말풍선을 만들어 줌
                            handleContentSendFileUpload(contentInformation, routingKey, "whisper-intensiveControl", msgInfo.userNickname, true);
                            if (getIsForPblModeBrowser()) {
                                const {
                                    uploadedPath,
                                    fileTransferType = "file-transfer",
                                    isAutoDownloadAllowed,
                                    executeYn,
                                    userNickname: infoUserNickname,
                                    originalFileName,
                                    contentSeq
                                } = contentInformation;
                                const finalIsAutoDownloadAllowed = executeYn === "Y" ? true : isAutoDownloadAllowed;

                                rcvChatFileShareHelper(
                                    uploadedPath,
                                    infoUserNickname || msgInfo.userNickname,
                                    routingKey,
                                    fileTransferType,
                                    finalIsAutoDownloadAllowed,
                                    originalFileName,
                                    contentSeq
                                );
                            }
                            break;

                        case "message":
                            // rcvChatText가 forceWhisper=true로 귓속말 말풍선을 만들어 줌
                            handleContentSendMessage(contentInformation, routingKey, "whisper-intensiveControl", msgInfo.userNickname, true);
                            if (getIsForPblModeBrowser()) {
                                const { message, userNickname: infoUserNickname } = contentInformation;

                                if (isNotEmptyStr(message)) {
                                    rcvChatTextHelper(message, infoUserNickname || msgInfo.userNickname, routingKey);
                                }
                            }
                            break;

                        default:
                            console.log("groupChatList - 알 수 없는 contentType => ", contentInformation.contentType);
                            store.dispatch(mqRcvGroupChatList({ list_groupChat: [chatItem] }));   // 알 수 없는 타입은 원본 그대로 표시
                            break;
                    }
                });
            } else {
                store.dispatch(mqRcvGroupChatList({ list_groupChat }));
            }
        }
    } else if (kind === "management") {
        console.log("rcvJsonData() - kind[", kind, "], action[", action, "], information => ", information);
        if (action === "remoteForwardResult") {
            store.dispatch(mqRcvRemoteForwardResult(information));
        }
    } else if (kind === "local") {
        // 20260828 관리자 명령 ACK를 해당 로컬 서버 카드에 반영한다.
        if (action === "commandAck") {
            store.dispatch(mqRcvLocalServerCommandAck(information));
        }
    } else if (kind === "remoteControl") {
        if (action === "start") {
            if (isAndroidWebView()) {
                // 20260807 Android 권한 처리에 요청 식별값과 만료 시간을 함께 전달한다.
                window.callRemoteControlStartPermCheck(information?.permissionRequestId, information?.timeoutMs);
            } else if (isWindowsWebView()) {
                let store = window.hiclasstv.store;
                const { user } = store.getState();
                const { userNickname, userSeq } = user;

                const data = {
                    kind: "handsup",
                    action: "remoteControl",
                    information: {
                        kind: "accept",
                        callKind: "web",
                        userSeq
                    }
                };

                sendJsonData(data, userNickname);

                window.chrome.webview.postMessage({
                    action: "remoteControl",
                    ...information
                });
            } else if (getIsForPblModeBrowser()) {
                // 20260714 ... PBL 모드 브라우저(Pentalk WiFi/PBLGroup - eoapi)도 RbmqPblRcvHelper.js를 통해
                // 원격 제어(remoteControl)를 지원하므로, notSupport가 아니라 accept 응답을 보낸다.
                // 실제 eoapi로의 전달은 RbmqPblRcvHelper.js의 rcvJsonDataHelper(kind==="remoteControl")에서
                // sendRemoteControlData로 병렬 처리되므로 여기서는 ack만 보낸다 ... by ri
                let store = window.hiclasstv.store;
                const { user } = store.getState();
                const { userNickname, userSeq } = user;

                const data = {
                    kind: "handsup",
                    action: "remoteControl",
                    information: {
                        kind: "accept",
                        callKind: "web",
                        userSeq
                    }
                };

                sendJsonData(data, userNickname);
            } else {
                let store = window.hiclasstv.store;
                const { user } = store.getState();
                const { userNickname, userSeq } = user;

                const data = {
                    kind: "handsup",
                    action: "remoteControl",
                    information: {
                        kind: "not_supported", // 260731 원격 제어 미지원 신규 메시지 규격 적용
                        callKind: "web",
                        userSeq
                    }
                };

                sendJsonData(data, userNickname);
            }
        } else if (action === "permission_cancel") {
            // 20260807 비Android 환경은 기존 흐름을 유지하고 Android에만 만료 취소를 전달한다.
            if (isAndroidWebView()) {
                window.callRemoteControlPermissionCancel(information?.permissionRequestId, information?.reason);
            }
        } else if (action === "end") {
            if (isAndroidWebView()) {
                window.callRemoteControlEnd();
            } else if (isWindowsWebView()) {
                window.chrome.webview.postMessage({
                    action: "remoteControl",
                    ...information
                });
            }
        } else if (action === "positionInfo") {
            if (isAndroidWebView()) {
                // 20260904 신규/구형 Pro 앱의 브리지 구분과 기존 필드별 전달은 Android helper에서 처리한다.
                window.callRemoteControlPositionInfo(information);
            } else if (isWindowsWebView()) {
                window.chrome.webview.postMessage({
                    action: "remoteControl",
                    kind: "positionInfo",
                    ...information
                });
            }
        } else if (action === "keyInfo") {
            if (isWindowsWebView()) {
                window.chrome.webview.postMessage({
                    action: "remoteControl",
                    kind: "keyInfo",
                    ...information
                });
            } else {
                console.log("key event not supported...");
            }
        } else if (action === "penstart" || action === "penend") {
            if (isWindowsWebView()) {
                window.chrome.webview.postMessage({
                    action: "remoteControl",
                    kind: action,
                    ...information
                });
            } else {
                console.log("pen event not supported...");
            }
        }
    } else if (kind === "intensiveControl" || kind === "whisper-intensiveControl") {
        // if (getIsForPblModeBrowser()) {
        //     return;
        // }

        if (action === "intensive-start") {
            if (isAndroidWebView()) {
                // 20260807 Android 권한 처리에 요청 식별값과 만료 시간을 함께 전달한다.
                window.callIntensiveControlStartPermCheck(information?.permissionRequestId, information?.timeoutMs);
            } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                let store = window.hiclasstv.store;
                const { user } = store.getState();
                const { userNickname, userSeq } = user;

                const data = {
                    kind: "handsup",
                    action: kind,
                    information: {
                        kind: "accept",
                        callKind: "web",
                        userSeq
                    }
                };

                sendJsonData(data, userNickname);

                window.chrome.webview.postMessage({
                    action: kind,
                    kind: "intensive-start",
                    ...information,
                });
            } else if (isIOSWebView()) {
                xmitCmd_IosMessage("intensive-start", information);
            } else {
                console.log("intensiveControl(intensive-start) not supported ... ");

                let store = window.hiclasstv.store;
                const { user } = store.getState();
                const { userNickname, userSeq } = user;

                const data = {
                    kind: "handsup",
                    action: kind,
                    information: {
                        kind: "notSupport",
                        callKind: "web",
                        userSeq
                    }
                };

                sendJsonData(data, userNickname);
            }

            // 모든 경우에 대해 intensive 모드 true로 설정함
            // notSupport & 안드로이드 권한 거절 모두 최소한
            // [끝내기] 버튼을 누를 수 없게 처리하기 위해서임 ... by hjkim 20260226
            store.dispatch(toggleIntensiveControlMode({ status: true }));
        } else if (action === "permission_cancel") {
            // 20260807 비Android 환경은 기존 흐름을 유지하고 Android에만 만료 취소를 전달한다.
            if (isAndroidWebView()) {
                window.callIntensiveControlPermissionCancel(information?.permissionRequestId, information?.reason);
            }
        } else if (action === "intensive-end") {
            if (isAndroidWebView()) {
                console.log("case 1:) call window.callIntensiveControlEnd().");
                window.callIntensiveControlEnd();
            } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                console.log("case 1:) call window.chrome.webview.postMessage({ kind: 'intensive-end' }).");
                window.chrome.webview.postMessage({
                    action: kind,
                    kind: "intensive-end",
                    ...information,
                });
            } else if (isIOSWebView()) {
                xmitCmd_IosMessage("intensive-end", information);
            } else {
                console.log("case 1:) intensiveControl(intensive-end) not supported ... ");
            }

            // 모든 경우에 대해 intensive 모드 false로 설정함
            // notSupport & 안드로이드 권한 거절 모두 최소한
            // [끝내기] 버튼을 누를 수 없게 처리되었기 때문 ... by hjkim 20260226
            store.dispatch(toggleIntensiveControlMode({ status: false }));
        } else if (action === "url-list") {
            const { list, contentSeq, refContentSeq } = information; // { name, url } - name: 목록에 표시될 이름, url: 실제 웹 사이트 주소
            console.log("'url-list' 수신 완료. list => ", list);

            let store = window.hiclasstv.store;
            const { user } = store.getState();
            const { userNickname, userSeq } = user;

            if (isAndroidWebView() || isWindowsWebView() || isIOSWebView()) {
                // 안드로이드 & 윈도우 & iOS WebView는 실행 후 received 응답
                if (isAndroidWebView()) {
                    window.callAllowWebSiteList(JSON.stringify({
                        ...information,
                        responseAction: kind,
                    }));
                } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                    console.log("isWindowsWebView - call window.chrome.webview.postMessage ... sendData => ", { ...information, kind: "url-list" });
                    window.chrome.webview.postMessage({
                        action: kind,
                        kind: "url-list",
                        ...information,
                    });
                } else if (isIOSWebView()) {
                    // 여기에 ios 하시오. (허가된 웹 사이트 주소 목록 전달)
                    console.log("url-list 수신 완료. ios 웹뷰에 전달해야 함.");
                    xmitCmd_IosMessage("url-list", {
                        ...information,
                        responseAction: kind,
                    });
                }

                const data = {
                    kind: "live",
                    action: kind,
                    information: {
                        kind: "content-send-ack",
                        contentType: "url-list",
                        contentSeq,
                        userSeq,
                        status: "received",      // 정상 수신
                    }
                };
                sendJsonData(data, userNickname);
            } else {
                // PC 웹 브라우저 등 미지원 기기
                console.log("url-list not supported ... ");

                const data = {
                    kind: "live",
                    action: kind,
                    information: {
                        kind: "content-send-ack",
                        contentType: "url-list",
                        contentSeq,
                        userSeq,
                        status: "not_support",   // 미지원 기기
                    }
                };
                sendJsonData(data, userNickname);
            }
        } else if (action === "url-start") {
            handleContentSendUrlStart(information, routingKey, kind);
        } else if (action === "app-start") {
            handleContentSendAppStart(information, routingKey, kind);
        } else if (action === "file-preparing") {
            // 20260901 추가: PBL이 아닌 Pro 학생도 믹스드 파일 컨텐츠 준비 상태를 먼저 확인한다.
            if (!getIsForPblModeBrowser()) showMixedCloudFilePreparing(information, userNickname, routingKey);
        } else if (action === "file-upload") {
            // 실시간 수신 시에는 whisper-intensiveControl일 때만 귓속말 말풍선, intensiveControl은 항상 일반 말풍선 ... by ri 20260710
            handleContentSendFileUpload(information, routingKey, kind, "", kind === "whisper-intensiveControl");
        } else if (action === "message") {
            // 실시간 수신 시에는 whisper-intensiveControl일 때만 귓속말 말풍선, intensiveControl은 항상 일반 말풍선 ... by ri 20260710
            handleContentSendMessage(information, routingKey, kind, "", kind === "whisper-intensiveControl");
        } else if (action === "switch-main-tab") {
            const { contentSeq, refContentSeq } = information;
            console.log("'switch-main-tab' 수신 완료 - information => ", information);

            let store = window.hiclasstv.store;
            const { user } = store.getState();
            const { userNickname, userSeq } = user;

            if (isAndroidWebView() || isWindowsWebView() || isIOSWebView()) {
                // 안드로이드 & 윈도우 & iOS WebView는 실행 후 received 응답
                if (isAndroidWebView()) {
                    // contentSeq 유무에 따라 메인 탭 전환 / contentSeq 탭 전환을 자동 분기
                    window.callSwitchTab({
                        ...information,
                        responseAction: kind,
                    });
                } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                    window.chrome.webview.postMessage({
                        action: kind,
                        kind: "switch-main-tab",
                        ...information,
                    });
                } else if (isIOSWebView()) {
                    // 여기에 ios 하시오. (전달된 url로 웹뷰 띄우기)
                    console.log("switch-main-tab 수신 완료. ios 웹뷰에 전달해야 함.");
                    xmitCmd_IosMessage("switch-main-tab", {
                        ...information,
                        responseAction: kind,
                    });
                }

                // contentSeq가 존재하는 경우에만 답변 전송하도록 수정 ... by hjkim 20260625
                if (contentSeq !== undefined && contentSeq !== null && contentSeq !== "") {
                    const data = {
                        kind: "live",
                        action: kind,
                        information: {
                            kind: "content-send-ack",
                            contentType: "switch-main-tab",
                            contentSeq,
                            userSeq,
                            status: "received",      // 정상 수신
                        }
                    };
                    sendJsonData(data, userNickname);
                } else {
                    console.log("switch-main-tab contentSeq does not exist ... ");
                }
            } else {
                // PC 웹 브라우저 등 미지원 기기
                console.log("switch-main-tab not supported ... ");

                // contentSeq가 존재하는 경우에만 답변 전송하도록 수정 ... by hjkim 20260625
                if (contentSeq !== undefined && contentSeq !== null && contentSeq !== "") {
                    const data = {
                        kind: "live",
                        action: kind,
                        information: {
                            kind: "content-send-ack",
                            contentType: "switch-main-tab",
                            contentSeq,
                            userSeq,
                            status: "not_support",   // 미지원 기기
                        }
                    };
                    sendJsonData(data, userNickname);
                } else {
                    console.log("switch-main-tab contentSeq does not exist ... ");
                }
            }
        } else if (action === "close-sub-tab") {
            const { contentSeq, refContentSeq } = information;
            console.log("'close-sub-tab' 수신 완료 - information => ", information);

            let store = window.hiclasstv.store;
            const { user } = store.getState();
            const { userNickname, userSeq } = user;

            if (isAndroidWebView() || isWindowsWebView() || isIOSWebView()) {
                // 안드로이드 & 윈도우 & iOS WebView는 실행 후 received 응답
                if (isAndroidWebView()) {
                    // contentSeq/refContentSeq 유무에 따라 해당 서브 탭 / 전체 서브 탭 닫기 자동 분기
                    window.callCloseSubTab({
                        ...information,
                        responseAction: kind,
                    });
                } else if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                    window.chrome.webview.postMessage({
                        action: kind,
                        kind: "close-sub-tab",
                        ...information,
                    });
                } else if (isIOSWebView()) {
                    // 여기에 ios 하시오. (전달된 url로 웹뷰 띄우기)
                    console.log("close-sub-tab 수신 완료. ios 웹뷰에 전달해야 함.");
                    xmitCmd_IosMessage("close-sub-tab", {
                        ...information,
                        responseAction: kind,
                    });
                }

                // contentSeq가 존재하는 경우에만 답변 전송하도록 수정 ... by hjkim 20260625
                if (contentSeq !== undefined && contentSeq !== null && contentSeq !== "") {
                    const data = {
                        kind: "live",
                        action: kind,
                        information: {
                            kind: "content-send-ack",
                            contentType: "close-sub-tab",
                            contentSeq,
                            userSeq,
                            status: "received",      // 정상 수신
                        }
                    };
                    sendJsonData(data, userNickname);
                } else {
                    console.log("close-sub-tab contentSeq does not exist ... ");
                }
            } else {
                // PC 웹 브라우저 등 미지원 기기
                console.log("close-sub-tab not supported ... ");

                // contentSeq가 존재하는 경우에만 답변 전송하도록 수정 ... by hjkim 20260625
                if (contentSeq !== undefined && contentSeq !== null && contentSeq !== "") {
                    const data = {
                        kind: "live",
                        action: kind,
                        information: {
                            kind: "content-send-ack",
                            contentType: "close-sub-tab",
                            contentSeq,
                            userSeq,
                            status: "not_support",   // 미지원 기기
                        }
                    };
                    sendJsonData(data, userNickname);
                } else {
                    console.log("close-sub-tab contentSeq does not exist ... ");
                }
            }
        } else if (action === "power-off") {
            // const { contentSeq, refContentSeq } = information;
            console.log("'power-off' 수신 완료");

            let store = window.hiclasstv.store;
            const { user } = store.getState();
            const { userNickname, userSeq } = user;

            if (isWindowsWebView() && !getIsForPblModeBrowser()) {
                // 윈도우 WebView도 received 응답 - 실행 전!
                const data = {
                    kind: "live",
                    action: kind,
                    information: {
                        kind: "content-send-ack",
                        contentType: "power-off",
                        // contentSeq,
                        userSeq,
                        status: "received",
                    }
                };
                sendJsonData(data, userNickname);

                window.chrome.webview.postMessage({
                    action: kind,
                    kind: "power-off",
                    ...information,
                });
            } else if (getIsForPblModeBrowser()) {
                // 20260916 PBL Group: PBL 전용 RabbitMQ 수신 helper가 eoapi.sendJson으로 이미 전달하므로
                // 여기서는 일반 Windows WebView의 not_support ACK를 보내지 않아 실제 수신 결과와 충돌하지 않게 한다.
                console.log("power-off forwarded to PBL Group program.");
            } else {
                console.log("power-off not supported ... ");

                const data = {
                    kind: "live",
                    action: kind,
                    information: {
                        kind: "content-send-ack",
                        contentType: "power-off",
                        // contentSeq,
                        userSeq,
                        status: "not_support",   // 미지원 기기
                    }
                };
                sendJsonData(data, userNickname);
            }
        }
    } else if (kind === "class_monitor") {
        if (action === "setUserScreenMode" && getCurrentPageType() === enWebPage.ClassMonitor && clientInfo.classMonitorUserScreenModeProc) {
            // 260803 SmartTV 최대화와 분리된 ClassMonitor 전용 JSON 요청을 전달한다.
            clientInfo.classMonitorUserScreenModeProc(information);
        } else if (action === "screenStateChanged" && clientInfo.classMonitorScreenStateProc) {
            // 260803 학생은 모니터 화면의 회신을 기준으로 다음 요청 모드를 결정한다.
            clientInfo.classMonitorScreenStateProc(information);
        }
    } else {
        console.log("kind is else... ", kind);
    }
}

/**
 * Mediasoup 서버에서 온 데이터 처리
 * @param {Object} dataObject       JsonObject로 kind, action, rtnVal 으로 구성됨
 */
const rcvJsonMessage = (dataObject) => {
    const { kind, action, rtnVal } = dataObject;
    console.log("jsonMessageRcv() => ", dataObject);
    if (isStaleLiveSendResponse(kind, action, dataObject.liveSeq)) { console.log(`jsonMessageRcv - 종료됐거나 다른 수업의 송출 응답이라 버린다. action[${action}], liveSeq[${dataObject.liveSeq}]`); return; } // 20261028 (web-relay R-224·R-232)

    if (action === "joinConsume") {
        joinConsumeAfter(rtnVal);
    } else if (action === "exitConsume") {
        exitConsumeAfter(rtnVal);
    } else if (action === "createConsumerTransport") {
        createConsumerTransportAfter(rtnVal);
    } else if (action === "connectConsumerTransport") {
        connectConsumerTransportAfter(rtnVal);
    } else if (action === "restartConsumerTransport") {
        // 260923 ICE 재시작 응답. kind 는 "mediaSoup" 으로 온다.
        restartConsumerTransportAfter(rtnVal);
    } else if (action === "newProducer") {
        newProducerAfter(kind, rtnVal);
    } else if (action === "displayRotationChanged") {
        // 260916 화면 보정 기능: 이미 송출 중인 producer의 회전값이 바뀌었다는 push 수신
        displayRotationChangedAfter(rtnVal);
    } else if (action === "live_produce") {
        const { id, kind } = rtnVal;
        produceAfter(rtnVal);
    } else if (action === "closeConsumer") {
        //const {kind,consumUserSeq} = rtnVal;
    } else if (action === "consume") {
        runLiveConsumeAfter(rtnVal, consumeAfter); // 20261028 consume 응답 처리 완료 후 같은 종류 대기 해제 (web-relay R-207)
    } else if (action === "resumeConsumer") {

    } else if (action === "resume") {
        resumeAfter(rtnVal);
    } else if (action === "unsubscrib") {
        unsubscribeAfter(rtnVal);
    } else if (action === "closeProducer" || action === "live_closeProducer") {
        closeProducerAfter(kind, rtnVal);
    } else if (action === "live_createProducerTransport") {
        createProducerTransportAfter(rtnVal);
    } else if (action === "live_connectProducerTransport") {
        console.log("chatGPT ---- ", rtnVal);
        connectProducerTransportAfter();
    } else if (action === "live_restartProducerTransport") {
        // 260923 ICE 재시작 응답. kind 는 "handsup" 으로 오지만 여기서는 action 만 본다.
        restartProducerTransportAfter(rtnVal);
    } else if (action === "live_unpublish") {
        unpublishAfter(rtnVal);
    } else if (action === "getState") {
        getStateAfter(rtnVal);
    }
}

export const rawDataWithRoutingKey = (rawData, routingKey) => {
    const dataObject = decodingPacket(rawData);
    // console.log("rawDataWithRoutingKey - ", dataObject);

    if (dataObject === undefined || dataObject === null) return;

    // ping 메시지는 로그 메시지로 출력되지 않도록 수정 ... by hjkim 20260326
    if (dataObject.CMD !== enTokenCMD.NULL && Object.keys(dataObject).length > 2) {
        console.log("rawDataWithRoutingKey - ", dataObject);
    }

    // 20250714 ... pbl 페이지면 helper도 호출
    // 20250731 ... pbl 페이지여도 데이터를 한 번만 디코딩하도록 메서드 호출 위치 이동함
    if (getIsForPblModeBrowser()) {
        rcvRawDataWithRoutingKeyHelper(dataObject, routingKey);
    }

    switch (dataObject.CMD) {
        case enTokenCMD.NULL:
            break;

        case enTokenCMD.Ink_SDn:
            drawInkStrokeDown(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_SM: // decode 1point
            drawInkStrokeMove(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_SDM: // decode 2point
            drawInkStrokeDoubleMove(dataObject.CMD, dataObject.SPT, dataObject.EPT);
            break;

        case enTokenCMD.Ink_SUp: // decode 1point
            drawInkStrokeUp(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_DDn:
            rcvAndroidPenDown(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_DM:
            rcvAndroidPenMove(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_DDM:
            rcvAndroidPenDoubleMove(dataObject.CMD, dataObject.SPT, dataObject.EPT);
            break;

        case enTokenCMD.Ink_DUp:
            rcvAndroidPenUp(dataObject.CMD, dataObject.SPT);
            break;

        case enTokenCMD.Ink_Erase1: // decode 2point
            eraseInkStroke(dataObject.CMD, dataObject.SPT, dataObject.EPT);
            break;

        case enTokenCMD.Ink_SingleStroke:
            drawInkStroke(dataObject.stroke);
            break;

        case enTokenCMD.Ink_PageStroke:
            // 여기 찍힘 !
            drawInkStrokes(dataObject.strokes, routingKey);
            break;

        case enTokenCMD.Ink_Clear: // decode command
            clearInkStroke(routingKey);
            break;

        case enTokenCMD.Ink_DefaultAttr:
            changeInkAttribute(dataObject.INT1, dataObject.BYTE1, dataObject.BYTE2, dataObject.BYTE3, dataObject.DOUBLE1, dataObject.DOUBLE2);
            break;

        case enTokenCMD.Ink_Mode: // decode 1byte
            changeInkMode(dataObject.byte1);
            break;

        case enTokenCMD.Ink_Color: // decode 3byte
            changeInkColor(dataObject.byte1, dataObject.byte2, dataObject.byte3);
            break;

        case enTokenCMD.Ink_Tip: // decode 2double
            changeInkTipSize(dataObject.double1, dataObject.double2);
            break;

        case enTokenCMD.page_PutArtifact:
        case enTokenCMD.cont_PageJpeg:
        case enTokenCMD.cont_StudentPageJpeg:
            // 이 command를 받는 경우 해당 user가 보낸 이미지를 받아서 내 화면에 뿌려야한다.
            rcvCmd_PagePut(dataObject.data, routingKey);
            break;

        case enTokenCMD.page_GetArtifact:
            // 이 command를 받는 경우 내 화면을 캡쳐해서 rest api로 쏴야한다.
            rcvCmd_PageGet("page_GetArtifact", enTokenCMD.page_PutArtifact);
            break;

        case enTokenCMD.cont_GetPageJpeg:
            rcvCmd_PageGet("cont_PageJpeg", enTokenCMD.cont_PageJpeg);
            break;

        case enTokenCMD.cont_GetStudentPageJpeg:
            rcvCmd_PageGet("cont_StudentPageJpeg", enTokenCMD.cont_StudentPageJpeg);
            break;

        case enTokenCMD.chat_FileName:
            rcvChatFile(dataObject.FileName, dataObject.name, routingKey);
            break;

        case enTokenCMD.chat_Text:
            rcvChatText(dataObject.name, dataObject.emoGIDno, dataObject.emoMIDno, dataObject.text, routingKey);
            break;

        case enTokenCMD.chat_Voice:
            rcvChatAudioMemo(dataObject.data, dataObject.name, routingKey);
            break;

        case enTokenCMD.chat_Memo:
            rcvChatInkMemo(dataObject.data, dataObject.name, routingKey);
            break;

        case enTokenCMD.ctl_PageInfo:
            // console.log("page info : ", dataObject);
            // chatPageScrollOffset(dataObject.data);
            break;

        case enTokenCMD.ct_UserLoginInfo:
            rcvUserStatus(dataObject.INT1, dataObject.INT2, dataObject.BYTE1, routingKey);
            break;

        case enTokenCMD.ct_UploadAndShareFiles:
            rcvChatFile(dataObject.FileName, dataObject.name, routingKey);
            break;

        case enTokenCMD.ct_SendToWebJSonInfo:
            const obj = JSON.parse(dataObject.text);

            if (obj.kind !== undefined && obj.kind !== null && obj.information !== undefined && obj.information !== null) {
                rcvJsonData(obj, dataObject.name, routingKey);
            } else {
                rcvJsonMessage(obj);
            }
            break;

        case enTokenCMD.ct_UpdateHandsUpImage:
            // console.log("enTokenCMD.ct_UpdateHandsUpImage - ", dataObject);
            if (getIsSmartTVMode()) {
                /* if (getIsAlivePenCamService()) {
                    if (getCurrentPageType() === enWebPage.GroupSmartTV) {
                        let userSeq = dataObject.INT2;
                        let store = window.hiclasstv.store;
                        const { hiclasstv } = store.getState();
                        const { list_isConnectedOnScreenApp } = hiclasstv;

                        const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
                        if (connectedOnScreenApp_info) {
                            let idx = list_isConnectedOnScreenApp.indexOf(connectedOnScreenApp_info);
                            if (clientInfo.funcProc) clientInfo.funcProc("update", dataObject.data, idx);
                        }
                    } else {
                        if (clientInfo.funcProc) clientInfo.funcProc("update", dataObject.data);
                    }
                } */

                // console.log("getCurrentPageType - ", getCurrentPageType());

                if (getCurrentPageType() === enWebPage.GroupSmartTV) {
                    let userSeq = dataObject.INT2;
                    if (getIsAlivePenCamService(userSeq)) {
                        const connectedOnScreenApp_info = getConnectedOnScreenAppInfo(userSeq);
                        if (connectedOnScreenApp_info) {
                            let idx = connectedOnScreenApp_info.idx;
                            if (idx > -1) {
                                if (clientInfo.funcProcArr) {
                                    let funcProc = clientInfo.funcProcArr[idx].funcProc;
                                    if (funcProc) {
                                        funcProc("update", dataObject.data, idx);
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if (getIsAlivePenCamService()) {
                        if (clientInfo.funcProc) clientInfo.funcProc("update", dataObject.data);
                    }
                }
            } else {
                // console.log("updateSmallGroupImage - update", dataObject);
                let store = window.hiclasstv.store;
                let liveSeq = dataObject.INT1;
                let userSeq = dataObject.INT2;
                const { live } = store.getState();
                const { isMixedClassMember } = live;
                if (isMixedClassMember) {
                    const { mixedClassInfo } = live;
                    if (mixedClassInfo.localLiveSeq === liveSeq) {
                        updateSmallGroupImage("update", mixedClassInfo.serverLiveSeq, userSeq, dataObject.data);
                    } else {
                        console.log(`ct_UpdateHandsUpImage - mixedClassInfo.localLiveSeq[${mixedClassInfo.localLiveSeq}], liveSeq[${liveSeq}]`);
                    }
                } else {
                    updateSmallGroupImage("update", liveSeq, userSeq, dataObject.data);
                }
            }
            break;

        case enTokenCMD.rq_PageClear:
            rcvClearPage(dataObject.CMD);
            break;

        default:
            console.log(`rawDataWithRoutingKey default case ... CMD[${dataObject.CMD}]`, dataObject);
            break;
    }
}

export const rawDataWithRoutingKeyForPentalk = (rawData, routingKey) => {
    const rawBinSring = window.atob(rawData);
    const len = rawBinSring.length;
    let rawBinData = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        rawBinData[i] = rawBinSring.charCodeAt(i);
    }

    const dataObject = decodingPacket(rawBinData);
    // console.log(dataObject);

    switch (dataObject.CMD) {

    }
}
